import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DoublingEditorComponent } from '../non-plc/costsavings/doubling-editor.component';
import { CstargetcostingService } from 'src/app/services/cstargetcosting-service.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MenuService } from 'src/app/services/menu.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { ProjectService } from 'src/app/services/project.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { Cscost } from 'src/app/models/Cscost';
import { ConfigurationLockService } from 'src/app/services/configuration-lock.service';
import { UnSavedChangesServiceService } from 'src/app/services/un-saved-changes-service.service';
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { messages } from 'src/app/popUpMessages/messages';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { CommentboxComponent } from 'src/app/commentbox/commentbox.component';
import { EnumModuleId } from 'src/app/enum/EnumModuleId';

let countryCode;

@Component({
  selector: 'app-tc-cs',
  templateUrl: './tc-cs.component.html',
  styleUrls: ['./tc-cs.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TcCSComponent implements OnInit, OnDestroy {
  @ViewChild('commentBox') commentBox: CommentboxComponent;

  showGrid: boolean = false;
  refTitle: string = "";
  tarTitle: string = "";
  optATitle: string = "";
  optBTitle: string = "";
  optCTitle: string = "";
  isEditable: boolean = false;
  roleBasedEditable: boolean = false;
  isLocked: boolean = false;
  lockedByUserId: string | null = null;
  lockedByUserName: string | null = null;
  public submitted: boolean = false;
  //grid Structure
  refGridApi: any;
  refColumnDefs: any;
  refDefaultColDef: any;
  refGridData: any;
  refPinnedBottomData: any;
  public refFrameworkComponents;
  rowClassRulesRef: any;
  rowClassRulesTar: any;
  rowClassRulesOptA: any;
  rowClassRulesOptB: any;
  rowClassRulesOptC: any;

  //refprice grid structure
  refPriceGridApi: any;
  refPriceColumnDefs: any;
  refPriceDefaultColDef: any;
  PriceGridData: any;
  refPricePinnedBottomData: any;
  public refPriceFrameworkComponents;

  //tar price grid structure
  tarPriceGridApi: any;
  tarPriceColumnDefs: any;
  tarPriceDefaultColDef: any;
  tarPricePinnedBottomData: any;
  public tarPriceFrameworkComponents;

  tarGridApi: any;
  tarPinnedBottomData: any;
  tarColumnDefs: any;
  tarDefaultColDef: any;
  tarGridData: any;
  public tarFrameworkComponents;
  public tarDomLayout: any;
  public domLayout: any;
  public modifiedRefCSRows = [];
  public modifiedTarCSRows = [];
  public modifiedOptACSRows = [];
  public modifiedOptBCSRows = [];
  public modifiedOptCCSRows = [];
  optAVisible: boolean = false;
  optBVisible: boolean = false;
  optCVisible: boolean = false;
  csMasterData: any;
  projectId: any;
  hasUnsavedChanges: boolean = false;
  hasCommentUnsavedChanges: boolean = false;
  public businessAreaId: number;
  public businessLineId: number;
  public userInOrg: any;
  public allUserList: any;

  optAGridApi: any;
  optAPinnedBottomData: any;
  optAColumnDefs: any;
  optAGridData: any[];
  optADefaultColDef: any;
  optACCRTargetCost: any;
  optACCRActuals: any;
  optACCRForecast: any;
  public optAFrameworkComponents;

  optAPriceGridApi: any;
  optAPriceColumnDefs: any;
  optAPriceDefaultColDef: any;
  optAPricePinnedBottomData: any;
  public optAPriceFrameworkComponents;

  optBGridApi: any;
  optBPinnedBottomData: any;
  optBGridData: any[];
  optBDefaultColDef: any;
  optBColumnDefs: any;
  optBCCRTargetCost: any;
  optBCCRActuals: any;
  optBCCRForecast: any;
  public optBFrameworkComponents;

  optBPriceGridApi: any;
  optBPriceColumnDefs: any;
  optBPriceDefaultColDef: any;
  optBPricePinnedBottomData: any;
  public optBPriceFrameworkComponents;

  optCGridApi: any;
  optCPinnedBottomData: any;
  optCDefaultColDef: any;
  optCGridData: any[];
  optCColumnDefs: any;
  optCCCRTargetCost: any;
  optCCCRActuals: any;
  optCCCRForecast: any;
  public optCFrameworkComponents;

  optCPriceGridApi: any;
  optCPriceColumnDefs: any;
  optCPriceDefaultColDef: any;
  optCPricePinnedBottomData: any;
  public optCPriceFrameworkComponents;

  projectSubmitterId: any;
  submitResponse: any;
  objData: { projectId: any; moduleId: any; configurationId: any };
  moduleId: number = 7;
  refCCRCost: any;
  tarCCRTargetCost: any;
  tarCCRActuals: any;
  tarCCRForecast: any;
  configurationId: any;
  refCCRId: any;
  tarCCRTargetCostId: any;
  tarCCRActualsId: any;
  tarCCRForecastId: any;
  optACCRTargetCostId: any;
  optACCRActualsId: any;
  optACCRForecastId: any;
  optBCCRTargetCostId: any;
  optBCCRActualsId: any;
  optBCCRForecastId: any;
  optCCCRTargetCostId: any;
  optCCCRActualsId: any;
  optCCCRForecastId: any;

  rowHeight: number;
  headerHeight: number;
  configSub: any;
  lockStatusSub: any;
  unsavedSub: any;
  private destroy$ = new Subject<void>();
  lockStatusInfo: any;
  rowClassRulesRefPrice: { colorTotal: (params: any) => boolean; };
  rowClassRulesTarPrice: { colorTotal: (params: any) => boolean; };

  rowClassRulesOptAPrice: { colorTotal: (params: any) => boolean; };
  rowClassRulesOptBPrice: { colorTotal: (params: any) => boolean; };
  rowClassRulesOptCPrice: { colorTotal: (params: any) => boolean; };

  constructor(
    private toast: ToasterService,
    private sharedService: SharedServiceService,
    private projectService: ProjectService,
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private router: Router,
    private menuService: MenuService,
    private CstargetcostingService: CstargetcostingService,
    private userService: UserInfoService,
    private configurationLockService: ConfigurationLockService,
    private unSavedChangeService: UnSavedChangesServiceService
  ) {
    this.refPriceFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };

    this.tarPriceFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };

    this.optAPriceFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };

    this.optBPriceFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };

    this.optCPriceFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  ngOnInit(): void {
    this.sharedService.getProjectIdAndTitle();

    this.projectId = this.localStorageService.get("projectId");
    // this.objData = {
    //   projectId: this.projectId,
    //   moduleId: this.moduleId,
    //   configurationId: undefined
    // }

    countryCode = this.localStorageService.get('countryCode');

    // Subscribe to configurationId changes
    this.configSub = this.sharedService.configurationId
      .pipe(
        filter(configId => !!configId),
        distinctUntilChanged()
      )
      .subscribe(configId => {
        this.configurationId = configId;
        this.objData = {
          projectId: this.projectId,
          moduleId: Number(EnumModuleId.CSTargetCost),
          configurationId: this.configurationId
        }

        // Pass objData to commentbox component
        if (this.commentBox) {
          this.commentBox.updateCommentData(this.objData);
        }
      });

    this.unsavedSub = this.unSavedChangeService.checkRequest$.subscribe(() => {
      if (this.hasUnsavedChanges || this.hasCommentUnsavedChanges) {
        const unSavedDialog = this.dialog.open(DialogComponent, { data: { message: messages.UnsavedChanges, okBtn: "Yes", cancelBtn: "No" } })
        unSavedDialog.afterClosed().subscribe(async result => {
          if (result === true) {
            // await this.submit();
            const submitResult = await this.submit();
            if (submitResult !== false) {
              this.unSavedChangeService.respondCheck(true); // Proceed
            }
            else {
              this.unSavedChangeService.respondCheck(false); // Proceed (discard)
            }
          } else {
            this.hasUnsavedChanges = false; // Reset unsaved changes flag
            this.unSavedChangeService.respondCheck(true); // Proceed (discard)
          }
        });
      }
      else {
        this.unSavedChangeService.respondCheck(true);
        // return;
      }
    });

    if (this.projectId != null) {
      this.projectService.getTCData(this.projectId).subscribe((data: any) => {
        if (data.StatusCode == 200) {
          this.businessAreaId = data.Data.BusinessAreaId;
          this.businessLineId = data.Data.BusinessLineId;
          this.sharedService.loggedInUser.subscribe((user: any) => {
            if (user) {
              this.showGrid = true
              this.userService.getUserList(this.businessAreaId, this.businessLineId).subscribe((d) => {
                this.allUserList = d;
                this.userInOrg = this.allUserList.find(u => u.Email == user.Email);
                if (this.userInOrg != undefined) {

                  this.projectSubmitterId = this.userInOrg.UserId;

                  let userIsFinancialController = data.Data.FinancialControllerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsFinancialControllerProxy = data.Data.FinancialControllerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  // let userIsSubmitter = data.Data.SubmitterId.split(',').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProductManager = data.Data.ProductManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProductManagerProxy = data.Data.ProductManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProjectManager = data.Data.ProjectManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProjectManagerProxy = data.Data.ProjectManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsServiceManager = data.Data.ServiceManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsServiceManagerProxy = data.Data.ServiceManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProcurementEngineer = data.Data.ProcurementEngineerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProcurementEngineerproxy = data.Data.ProcurementEngineerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsSystemArchitect = data.Data.SystemArchitectIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsSystemArchitectProxy = data.Data.SystemArchitectProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsWatchList = data.Data.WatchListIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);

                  if (this.userInOrg.TargetRoleId == 1) {
                    this.roleBasedEditable = true;
                  }
                  else if (this.userInOrg.TargetRoleId == 3 || this.userInOrg.TargetRoleId == 2) {
                    if (data.Data.SubmitterId == this.userInOrg.UserId || userIsFinancialController || userIsFinancialControllerProxy
                      || userIsProductManager || userIsProductManagerProxy || userIsProjectManager || userIsProjectManagerProxy
                      || userIsProcurementEngineer || userIsProcurementEngineerproxy
                      || userIsSystemArchitect || userIsSystemArchitectProxy || userIsWatchList || userIsServiceManager || userIsServiceManagerProxy
                    ) {
                      this.roleBasedEditable = true;
                    }
                    else {
                      this.roleBasedEditable = false;
                    }
                  }
                }
                this.lockStatusSub = this.configurationLockService.lockStatus$
                  .pipe(
                    filter(lockStatus => lockStatus !== null)
                  )
                  .subscribe(lockStatus => {
                    // Only call loadData if lockStatus is for the current configId
                    if (lockStatus.ConfigId == this.configurationId) {
                      this.lockStatusInfo = lockStatus;
                      this.isEditable = lockStatus.isLocked && lockStatus.lockedByUserId === this.userInOrg?.UserId
                        ? this.roleBasedEditable
                        : false;
                      this.loadData();
                    }
                  });

                // this.loadRefGridStructure();
                // this.loadTarGridStructure();
                // this.loadOptAGridStructure();
                // this.loadOptBGridStructure();
                // this.loadOptCGridStructure();
              })
            }
          })
        }
      });
    } else {
      this.businessAreaId = this.businessLineId = 0;
    }
    // Add event listener for tab/browser close
    // window.addEventListener('beforeunload', this.handleTabClose.bind(this));
  }

  // Update isEditable based on lock status
  private updateEditabilityBasedOnLock(lockStatus: any): void {
    if (lockStatus.isLocked || lockStatus.lockedByUserId === this.userInOrg?.UserId) {
      this.isEditable = this.roleBasedEditable;  // Unlocked or locked by self
    } else {
      this.isEditable = false;  // Locked by another user
    }
  }

  addNewRow() {
    const emptyScenario = () => ({
      TargetCost: { Id: null, PerSystem: null, ActualMEKs: null },
      Forecast: { Id: null, PerSystem: null, ActualMEKs: null }
    });
    if (this.optAVisible == true && this.optBVisible == true) {
      this.optCVisible = true;
      this.hasUnsavedChanges = true;
      for (let i of this.PriceGridData) {
        i.OptionC = emptyScenario();
      }
    }
    if (this.optAVisible == true) {
      this.optBVisible = true;
      this.hasUnsavedChanges = true;
      for (let i of this.PriceGridData) {
        i.OptionB = emptyScenario();
      }
    }
    if (this.optBVisible == false) {
      this.optAVisible = true;
      this.hasUnsavedChanges = true;
      for (let i of this.PriceGridData) {
        i.OptionA = emptyScenario();
      }
    }
  }

  loadData() {
    this.hasUnsavedChanges = false;
    this.showGrid = false;
    this.optAVisible = false;
    this.optBVisible = false;
    this.optCVisible = false;

    this.modifiedRefCSRows = [];
    this.modifiedTarCSRows = [];
    this.modifiedOptACSRows = [];
    this.modifiedOptBCSRows = [];
    this.modifiedOptCCSRows = [];

    forkJoin({
      csData: this.CstargetcostingService.getCsTargetcostingData(this.configurationId),
      priceData: this.CstargetcostingService.getPriceCalculationData(this.configurationId)
    }).subscribe(({ csData, priceData }) => {
      const csErrorMessage = csData?.Data?.Message ?? '';
      const priceErrorMessage = priceData?.Data?.Message ?? '';

      if (csData.StatusCode !== 200) {
        const errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + csErrorMessage]: serverMessage.serverErrorHeader }
        ];
        this.openAlertDialog(errorContainer);
        return;
      }

      if (priceData.StatusCode !== 200) {
        const errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + priceErrorMessage]: serverMessage.serverErrorHeader }
        ];
        this.openAlertDialog(errorContainer);
        return;
      }

      this.showGrid = true;
      this.csMasterData = csData.Data;

      const PRICE_ORDER = [
        'Price',
        'Service costs Target',
        'Delta Total Service costs to Service costs Target'
      ];

      this.PriceGridData = (priceData.Data as any[])
        .filter(row => PRICE_ORDER.includes((row.Description ?? '').trim()))
        .sort((a, b) =>
          PRICE_ORDER.indexOf((a.Description ?? '').trim()) -
          PRICE_ORDER.indexOf((b.Description ?? '').trim())
        );

      for (let i of this.PriceGridData) {
        i["IsEditable"] = this.isEditable;
      }
      if (this.csMasterData[0].OptionA) this.optAVisible = true;
      if (this.csMasterData[0].OptionB) this.optBVisible = true;
      if (this.csMasterData[0].OptionC) this.optCVisible = true;

      this.refTitle = this.csMasterData[0].ReferenceScenario.ScenarioTitle ?? "";
      this.tarTitle = this.csMasterData[0].TargetScenario.ScenarioTitle ?? "";
      this.optATitle = this.csMasterData[0].OptionA?.ScenarioTitle ?? "";
      this.optBTitle = this.csMasterData[0].OptionB?.ScenarioTitle ?? "";
      this.optCTitle = this.csMasterData[0].OptionC?.ScenarioTitle ?? "";

      this.refGridData = [];
      this.tarGridData = [];
      this.optAGridData = [];
      this.optBGridData = [];
      this.optCGridData = [];

      for (let i of this.csMasterData) {
        i["IsEditable"] = this.isEditable;

        if (i.Service == "Margin in %") {
          continue;
        }

        if (i.Service == "CCR") {
          this.refCCRCost = i.ReferenceScenario.Cost;
          this.refCCRId = i.ReferenceScenario.CSId;

          this.tarCCRTargetCost = i.TargetScenario.TargetCost?.Cost ?? 0;
          this.tarCCRActuals = i.TargetScenario.Actuals?.Cost ?? 0;
          this.tarCCRForecast = i.TargetScenario.ForeCast?.Cost ?? 0;

          this.optACCRTargetCost = i.OptionA?.TargetCost?.Cost ?? 0;
          this.optACCRActuals = i.OptionA?.Actuals?.Cost ?? 0;
          this.optACCRForecast = i.OptionA?.ForeCast?.Cost ?? 0;

          this.optBCCRTargetCost = i.OptionB?.TargetCost?.Cost ?? 0;
          this.optBCCRActuals = i.OptionB?.Actuals?.Cost ?? 0;
          this.optBCCRForecast = i.OptionB?.ForeCast?.Cost ?? 0;

          this.optCCCRTargetCost = i.OptionC?.TargetCost?.Cost ?? 0;
          this.optCCCRActuals = i.OptionC?.Actuals?.Cost ?? 0;
          this.optCCCRForecast = i.OptionC?.ForeCast?.Cost ?? 0;

          this.tarCCRTargetCostId = i.TargetScenario.TargetCost?.CSId ?? null;
          this.tarCCRActualsId = i.TargetScenario.Actuals?.CSId ?? null;
          this.tarCCRForecastId = i.TargetScenario.ForeCast?.CSId ?? null;

          this.optACCRTargetCostId = i.OptionA?.TargetCost?.CSId ?? null;
          this.optACCRActualsId = i.OptionA?.Actuals?.CSId ?? null;
          this.optACCRForecastId = i.OptionA?.ForeCast?.CSId ?? null;

          this.optBCCRTargetCostId = i.OptionB?.TargetCost?.CSId ?? null;
          this.optBCCRActualsId = i.OptionB?.Actuals?.CSId ?? null;
          this.optBCCRForecastId = i.OptionB?.ForeCast?.CSId ?? null;

          this.optCCCRTargetCostId = i.OptionC?.TargetCost?.CSId ?? null;
          this.optCCCRActualsId = i.OptionC?.Actuals?.CSId ?? null;
          this.optCCCRForecastId = i.OptionC?.ForeCast?.CSId ?? null;
        }

        if (i.Service != "Total Service costs" && i.Service != "CCR") {
          this.refGridData.push({
            CSId: i.CSId,
            ConfigurationId: i.ConfigurationId,
            Service: i.Service,
            Costs: i.ReferenceScenario.Cost,
            IsActive: i.IsActive,
            CreatedBy: i.CreatedBy,
            CreatedOn: i.CreatedOn,
            ModifiedBy: i.ModifiedBy,
            ModifiedOn: i.ModifiedOn,
            IsEditable: this.isEditable,
          });

          this.tarGridData.push({
            CSIdTargetCost: i.TargetScenario.TargetCost?.CSId ?? 0,
            CSIdForecast: i.TargetScenario.ForeCast?.CSId ?? 0,
            CSIdActuals: i.TargetScenario.Actuals?.CSId ?? 0,
            ConfigurationId: i.ConfigurationId,
            Service: i.Service,
            ReferenceCost: i.ReferenceScenario.Cost,
            TargetCosts: i.TargetScenario.TargetCost?.Cost ?? null,
            Forecast: i.TargetScenario.ForeCast?.Cost ?? null,
            Actuals: i.TargetScenario.Actuals?.Cost ?? null,
            DeltaTCVsRef: i.TargetScenario.TargetCost?.DeltaTCvsRefrence ?? null,
            DeltaFCVsRef: i.TargetScenario.ForeCast?.DeltaFCvsRefrence ?? null,
            DeltaACTVsRef: i.TargetScenario.Actuals?.DeltaTCvsAct ?? null,
            IsActive: i.IsActive,
            CreatedBy: i.CreatedBy,
            CreatedOn: i.CreatedOn,
            ModifiedBy: i.ModifiedBy,
            ModifiedOn: i.ModifiedOn,
            IsEditable: this.isEditable,
          });

          this.optAGridData.push({
            CSIdTargetCost: i.OptionA?.TargetCost?.CSId ?? 0,
            CSIdForecast: i.OptionA?.ForeCast?.CSId ?? 0,
            CSIdActuals: i.OptionA?.Actuals?.CSId ?? 0,
            ConfigurationId: i.ConfigurationId,
            Service: i.Service,
            ReferenceCost: i.ReferenceScenario.Cost,
            TargetCosts: i.OptionA?.TargetCost?.Cost ?? null,
            Forecast: i.OptionA?.ForeCast?.Cost ?? null,
            Actuals: i.OptionA?.Actuals?.Cost ?? null,
            DeltaTCVsRef: i.OptionA?.TargetCost?.DeltaTCvsRefrence ?? null,
            DeltaFCVsRef: i.OptionA?.ForeCast?.DeltaFCvsRefrence ?? null,
            DeltaACTVsRef: i.OptionA?.Actuals?.DeltaTCvsAct ?? null,
            IsActive: i.IsActive,
            CreatedBy: i.CreatedBy,
            CreatedOn: i.CreatedOn,
            ModifiedBy: i.ModifiedBy,
            ModifiedOn: i.ModifiedOn,
            IsEditable: this.isEditable,
          });

          this.optBGridData.push({
            CSIdTargetCost: i.OptionB?.TargetCost?.CSId ?? 0,
            CSIdForecast: i.OptionB?.ForeCast?.CSId ?? 0,
            CSIdActuals: i.OptionB?.Actuals?.CSId ?? 0,
            ConfigurationId: i.ConfigurationId,
            Service: i.Service,
            ReferenceCost: i.ReferenceScenario.Cost,
            TargetCosts: i.OptionB?.TargetCost?.Cost ?? null,
            Forecast: i.OptionB?.ForeCast?.Cost ?? null,
            Actuals: i.OptionB?.Actuals?.Cost ?? null,
            DeltaTCVsRef: i.OptionB?.TargetCost?.DeltaTCvsRefrence ?? null,
            DeltaFCVsRef: i.OptionB?.ForeCast?.DeltaFCvsRefrence ?? null,
            DeltaACTVsRef: i.OptionB?.Actuals?.DeltaTCvsAct ?? null,
            IsActive: i.IsActive,
            CreatedBy: i.CreatedBy,
            CreatedOn: i.CreatedOn,
            ModifiedBy: i.ModifiedBy,
            ModifiedOn: i.ModifiedOn,
            IsEditable: this.isEditable,
          });

          this.optCGridData.push({
            CSIdTargetCost: i.OptionC?.TargetCost?.CSId ?? 0,
            CSIdForecast: i.OptionC?.ForeCast?.CSId ?? 0,
            CSIdActuals: i.OptionC?.Actuals?.CSId ?? 0,
            ConfigurationId: i.ConfigurationId,
            Service: i.Service,
            ReferenceCost: i.ReferenceScenario.Cost,
            TargetCosts: i.OptionC?.TargetCost?.Cost ?? null,
            Forecast: i.OptionC?.ForeCast?.Cost ?? null,
            Actuals: i.OptionC?.Actuals?.Cost ?? null,
            DeltaTCVsRef: i.OptionC?.TargetCost?.DeltaTCvsRefrence ?? null,
            DeltaFCVsRef: i.OptionC?.ForeCast?.DeltaFCvsRefrence ?? null,
            DeltaACTVsRef: i.OptionC?.Actuals?.DeltaTCvsAct ?? null,
            IsActive: i.IsActive,
            CreatedBy: i.CreatedBy,
            CreatedOn: i.CreatedOn,
            ModifiedBy: i.ModifiedBy,
            ModifiedOn: i.ModifiedOn,
            IsEditable: this.isEditable,
          });
        }
      }

      this.loadRefGridStructure();
      this.loadRefPriceGridStructure();
      this.loadTarGridStructure();
      this.loadTarPriceGridStructure();
      this.loadOptAGridStructure();
      this.loadOptAPriceGridStructure();
      this.loadOptBGridStructure();
      this.loadOptBPriceGridStructure();
      this.loadOptCGridStructure();
      this.loadOptCPriceGridStructure();

      this.refreshPinnedRowsMargin();
    });
  }

  private refreshDeltaRow(): void {
    if (!this.PriceGridData) return;

    const deltaRow = this.PriceGridData.find((x: any) =>
      x.Description === 'Delta Total Service costs to Service costs Target');
    const esRow = this.PriceGridData.find((x: any) =>
      x.Description === 'Service costs Target');

    if (!deltaRow || !esRow) return;

    const n = (v: any) => Number(v ?? 0);

    // Reference — pinned row 0 of refGrid = Total Service Costs
    if (this.refGridApi) {
      const refTotal = this.refGridApi.getPinnedBottomRow(0)?.data?.Costs ?? 0;
      if (!deltaRow.ReferenceScenario) deltaRow.ReferenceScenario = {};
      deltaRow.ReferenceScenario.PerSystem = n(refTotal) - n(esRow.ReferenceScenario?.PerSystem);
    }

    // Target — pinned row 0 = Total Service Costs
    if (this.tarGridApi) {
      const t = this.tarGridApi.getPinnedBottomRow(0)?.data;
      if (!deltaRow.TargetScenario) deltaRow.TargetScenario = {};
      if (!deltaRow.TargetScenario.TargetCost) deltaRow.TargetScenario.TargetCost = {};
      if (!deltaRow.TargetScenario.Forecast) deltaRow.TargetScenario.Forecast = {};
      // if (!deltaRow.TargetScenario.Forecast.ActualMEKs) deltaRow.TargetScenario.Forecast.ActualMEKs = {};
      deltaRow.TargetScenario.TargetCost.PerSystem = n(t?.TargetCosts) - n(esRow.TargetScenario?.TargetCost?.PerSystem);
      deltaRow.TargetScenario.Forecast.PerSystem = n(t?.Forecast) - n(esRow.TargetScenario?.Forecast?.PerSystem);
      deltaRow.TargetScenario.Forecast.ActualMEKs = n(t?.Actuals) - n(esRow.TargetScenario?.Forecast?.ActualMEKs);
    }

    // Option A
    if (this.optAVisible && this.optAGridApi) {
      const t = this.optAGridApi.getPinnedBottomRow(0)?.data;
      if (!deltaRow.OptionA) deltaRow.OptionA = {};
      if (!deltaRow.OptionA.TargetCost) deltaRow.OptionA.TargetCost = {};
      if (!deltaRow.OptionA.Forecast) deltaRow.OptionA.Forecast = {};
      // if (!deltaRow.OptionA.Forecast.ActualMEKs) deltaRow.OptionA.Forecast.ActualMEKs = {};
      deltaRow.OptionA.TargetCost.PerSystem = n(t?.TargetCosts) - n(esRow.OptionA?.TargetCost?.PerSystem);
      deltaRow.OptionA.Forecast.PerSystem = n(t?.Forecast) - n(esRow.OptionA?.Forecast?.PerSystem);
      deltaRow.OptionA.Forecast.ActualMEKs = n(t?.Actuals) - n(esRow.OptionA?.Forecast?.ActualMEKs);
    }

    // Option B
    if (this.optBVisible && this.optBGridApi) {
      const t = this.optBGridApi.getPinnedBottomRow(0)?.data;
      if (!deltaRow.OptionB) deltaRow.OptionB = {};
      if (!deltaRow.OptionB.TargetCost) deltaRow.OptionB.TargetCost = {};
      if (!deltaRow.OptionB.Forecast) deltaRow.OptionB.Forecast = {};
      // if (!deltaRow.OptionB.Forecast.ActualMEKs) deltaRow.OptionB.Forecast.ActualMEKs = {};
      deltaRow.OptionB.TargetCost.PerSystem = n(t?.TargetCosts) - n(esRow.OptionB?.TargetCost?.PerSystem);
      deltaRow.OptionB.Forecast.PerSystem = n(t?.Forecast) - n(esRow.OptionB?.Forecast?.PerSystem);
      deltaRow.OptionB.Forecast.ActualMEKs = n(t?.Actuals) - n(esRow.OptionB?.Forecast?.ActualMEKs);
    }

    // Option C
    if (this.optCVisible && this.optCGridApi) {
      const t = this.optCGridApi.getPinnedBottomRow(0)?.data;
      if (!deltaRow.OptionC) deltaRow.OptionC = {};
      if (!deltaRow.OptionC.TargetCost) deltaRow.OptionC.TargetCost = {};
      if (!deltaRow.OptionC.Forecast) deltaRow.OptionC.Forecast = {};
      // if (!deltaRow.OptionC.Forecast.ActualMEKs) deltaRow.OptionC.Forecast.ActualMEKs = {};
      deltaRow.OptionC.TargetCost.PerSystem = n(t?.TargetCosts) - n(esRow.OptionC?.TargetCost?.PerSystem);
      deltaRow.OptionC.Forecast.PerSystem = n(t?.Forecast) - n(esRow.OptionC?.Forecast?.PerSystem);
      deltaRow.OptionC.Forecast.ActualMEKs = n(t?.Actuals) - n(esRow.OptionC?.Forecast?.ActualMEKs);
    }

    [
      this.refPriceGridApi,
      this.tarPriceGridApi,
      this.optAPriceGridApi,
      this.optBPriceGridApi,
      this.optCPriceGridApi,
    ].forEach(api => {
      if (!api) return;

      api.refreshCells({ force: true });
    });

  }

  refreshPinnedRowsMargin() {
    // CS grids — ONLY "Total Service Costs" (CCR removed from here)
    if (this.refGridApi) {
      this.refGridApi.setPinnedBottomRowData(createDataRef(this.totalRef(), this.isEditable));
    }
    if (this.tarGridApi) {
      this.tarGridApi.setPinnedBottomRowData(createDataTar(this.totalTar(), this.isEditable));
    }
    if (this.optAGridApi) {
      this.optAGridApi.setPinnedBottomRowData(createDataOptA(this.totalOptA(), this.isEditable));
    }
    if (this.optBGridApi) {
      this.optBGridApi.setPinnedBottomRowData(createDataOptB(this.totalOptB(), this.isEditable));
    }
    if (this.optCGridApi) {
      this.optCGridApi.setPinnedBottomRowData(createDataOptC(this.totalOptC(), this.isEditable));
    }

    // Price grids — CCR as pinned bottom row (preserve user-edited value if present)
    if (this.refPriceGridApi) {
      const cur = this.refPriceGridApi.getPinnedBottomRow(0)?.data;
      const cost = cur ? cur.ReferenceScenario?.PerSystem : this.refCCRCost;
      const id = cur ? cur.CSId : this.refCCRId;
      this.refPriceGridApi.setPinnedBottomRowData(createDataRefCCRPrice(cost, id, this.isEditable));
    }
    if (this.tarPriceGridApi) {
      const cur = this.tarPriceGridApi.getPinnedBottomRow(0)?.data;
      const tc = cur ? cur.TargetScenario?.TargetCost?.PerSystem : this.tarCCRTargetCost;
      const fc = cur ? cur.TargetScenario?.Forecast?.PerSystem : this.tarCCRForecast;
      const act = cur ? cur.TargetScenario?.Forecast?.ActualMEKs : this.tarCCRActuals;
      this.tarPriceGridApi.setPinnedBottomRowData(
        createDataTarCCRPrice(tc, fc, act, this.tarCCRTargetCostId, this.tarCCRForecastId, this.tarCCRActualsId, this.isEditable));
    }
    if (this.optAPriceGridApi) {
      const cur = this.optAPriceGridApi.getPinnedBottomRow(0)?.data;
      const tc = cur ? cur.OptionA?.TargetCost?.PerSystem : this.optACCRTargetCost;
      const fc = cur ? cur.OptionA?.Forecast?.PerSystem : this.optACCRForecast;
      const act = cur ? cur.OptionA?.Forecast?.ActualMEKs : this.optACCRActuals;
      this.optAPriceGridApi.setPinnedBottomRowData(
        createDataOptACCRPrice(tc, fc, act, this.optACCRTargetCostId, this.optACCRForecastId, this.optACCRActualsId, this.isEditable));
    }
    if (this.optBPriceGridApi) {
      const cur = this.optBPriceGridApi.getPinnedBottomRow(0)?.data;
      const tc = cur ? cur.OptionB?.TargetCost?.PerSystem : this.optBCCRTargetCost;
      const fc = cur ? cur.OptionB?.Forecast?.PerSystem : this.optBCCRForecast;
      const act = cur ? cur.OptionB?.Forecast?.ActualMEKs : this.optBCCRActuals;
      this.optBPriceGridApi.setPinnedBottomRowData(
        createDataOptBCCRPrice(tc, fc, act, this.optBCCRTargetCostId, this.optBCCRForecastId, this.optBCCRActualsId, this.isEditable));
    }
    if (this.optCPriceGridApi) {
      const cur = this.optCPriceGridApi.getPinnedBottomRow(0)?.data;
      const tc = cur ? cur.OptionC?.TargetCost?.PerSystem : this.optCCCRTargetCost;
      const fc = cur ? cur.OptionC?.Forecast?.PerSystem : this.optCCCRForecast;
      const act = cur ? cur.OptionC?.Forecast?.ActualMEKs : this.optCCCRActuals;
      this.optCPriceGridApi.setPinnedBottomRowData(
        createDataOptCCCRPrice(tc, fc, act, this.optCCCRTargetCostId, this.optCCCRForecastId, this.optCCCRActualsId, this.isEditable));
    }

    this.refreshDeltaRow();
  }

  loadRefGridStructure() {
    this.rowClassRulesRef = {
      'colorTotal': function (params) {
        let data = params.data.Service;
        return data === 'Total Service Costs';
      }
    }

    this.refColumnDefs = [
      {
        headerName: "Service",
        field: "Service",
        tooltipField: "service",
        width: 250,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Service",
        editable: false
      },
      {
        headerName: "Costs",
        field: "Costs",
        tooltipField: "Costs",
        width: 130,
        headerTooltip: "Costs",
        tooltipValueGetter: CurrencyCellRenderer,
        valueGetter: function (params) {
          if (params.node.data.Service === 'Total Service Costs') {
            let total = 0;

            if (params.api != null) {
              params.api.forEachNode((node) => {

                total += Number(node.data.Costs)
              })
              params.data.Costs = total;
              return total;
            }
          } else {
            return (params.data.Costs);
          }
        },
        cellEditor: 'doublingEditor',
        editable: (params) => {
          if (params.node.data.Service === 'Total Service Costs') {
            return false;
          }
          else {
            return params.data.IsEditable;
          }
        },
        cellRenderer: CurrencyCellRenderer,
        singleClickEdit: true,
      }
    ];

    this.refDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.domLayout = 'autoHeight';
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.refFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onRefGridReady(params: any) {
    this.refGridApi = params.api;
    // this.refGridApi.setHeaderHeight(77.667);
    this.refGridApi.setHeaderHeight(0);
    this.refPinnedBottomData = createDataRef(this.totalRef(), this.isEditable);
    params.api.setPinnedBottomRowData(this.refPinnedBottomData);
    if (this.PriceGridData) { this.refreshPinnedRowsMargin(); }  // <-- add
  }

  onGridRefCSChanged(params) {
    this.refGridApi = params.api;
    this.refGridApi.sizeColumnsToFit();
  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedRef(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleRef(params) {
    params.api.resetRowHeights();
  }

  onRefCellValueChangedCS(params) {
    this.hasUnsavedChanges = true;
    if (params.data.Service != "CCR") {
      let tar = this.tarGridData.find(x => x.Service == params.data.Service)
      tar.ReferenceCost = params.data.Costs
      this.tarGridApi.redrawRows();

      let optA = this.optAGridData.find(x => x.Service == params.data.Service)
      optA.ReferenceCost = params.data.Costs
      if (this.optAGridApi != undefined) this.optAGridApi.redrawRows();

      let optB = this.optBGridData.find(x => x.Service == params.data.Service)
      optB.ReferenceCost = params.data.Costs
      if (this.optBGridApi != undefined) this.optBGridApi.redrawRows();

      let optC = this.optCGridData.find(x => x.Service == params.data.Service)
      optC.ReferenceCost = params.data.Costs
      if (this.optCGridApi != undefined) this.optCGridApi.redrawRows();
    }


    //   if (params.data.configurationId      != 0) {
    let isPushed = false;
    if (this.modifiedRefCSRows.length == 0) {
      this.modifiedRefCSRows.push(params.data);
      isPushed = true;
    }
    else {
      this.modifiedRefCSRows.forEach((row, index) => {
        if (params.data.ConfigurationId
          == row.ConfigurationId && params.data.CSId == row.CSId && params.data.Service == row.Service
        ) {
          // row = params.data;
          // this.modifiedCSRows[index] = params.data;
          isPushed = true;
        }
      })
    }
    if (!isPushed) {
      this.modifiedRefCSRows.push(params.data);
    }
    this.refreshPinnedRowsMargin();
    // }
  }

  // calculate total for reference grid for bottom "total row"
  totalRef() {
    let costs = 0
    this.refGridApi.forEachNode(function (node) {
      costs = Number(node.data.Costs) + costs
    })
    return costs;
  }

  loadRefPriceGridStructure() {
    this.rowClassRulesRefPrice = {
      'colorTotal': function (params) {
        let data = params.data.Description;
        // REMOVED: Price and Expected Service Costs from colorTotal
        return data === 'Delta Total Service costs to Service costs Target';
      }
    }
    this.refPriceColumnDefs = [
      {
        headerName: "Service",
        field: "Description",
        tooltipField: "Description",
        width: 250,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Description",
        editable: false
      },
      {
        headerName: "Costs",
        field: "ReferenceScenario.PerSystem",
        tooltipField: "Costs",
        width: 130,
        headerTooltip: "Costs",
        tooltipValueGetter: CurrencyCellRenderer,
        cellEditor: 'doublingEditor',
        cellClass: (params) => {
          if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
            const v = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
            return v >= 0 ? 'positive-num-color-cs' : 'negative-num-color-cs';
          }
          return '';
        },
        editable: (params) => {
          if (params.node.data.Description === 'Delta Total Service costs to Service costs Target') {
            return false;
          }
          return params.data.IsEditable;
        },
        valueFormatter: PriceGridValueFormatter,
        valueGetter: (params) => params.data.ReferenceScenario?.PerSystem,
        valueSetter: (params) => {
          if (!params.data.ReferenceScenario) params.data.ReferenceScenario = {};
          const raw = params.newValue;
          const val = (raw === null || raw === undefined) ? null : Number(String(raw).replace(/,/g, ''));
          params.data.ReferenceScenario.PerSystem = isNaN(val as any) ? null : val;
          return true;
        },
        singleClickEdit: true,
      }
    ];
    this.refPriceDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      wrapText: true,
    };
    this.rowHeight = 25;
  }

  onRefPriceGridReady(params: any) {
    this.refPriceGridApi = params.api;
    params.api.setHeaderHeight(77.677);
    params.api.sizeColumnsToFit();
  }

  onFirstDataRenderedRefPrice(params) {
    this.refreshPinnedRowsMargin();
    // let model = {
    //   Description: {
    //     filterType: 'set', type: 'notEqual',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // };
    // this.refPriceGridApi.setFilterModel(model);
    // this.refPriceGridApi.onFilterChanged();
    // this.refPriceGridApi.redrawRows();
    // params.api.setFilterModel({
    //   Description: {
    //     filterType: 'set',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // });
    // params.api.onFilterChanged();
  }

  onRefPriceCellValueChangedCS(params) {
    this.hasUnsavedChanges = true;
    this.refreshPinnedRowsMargin();
  }

  onColumnResizedRefPrice(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleRefPrice(params) {
    params.api.resetRowHeights();
  }

  onGridRefPriceCSChanged(params) {
    this.refPriceGridApi = params.api;
    this.refPriceGridApi.sizeColumnsToFit();
  }

  loadTarGridStructure() {
    this.rowClassRulesTar = {
      'colorTotal': function (params) {
        let data = params.data.Service;
        return data === 'Total Service Costs';
      }
    }

    this.tarColumnDefs = [
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Target Costs",
            headerClass: "right-border",
            cellClass: "right-border",
            field: "TargetCosts",
            tooltipField: "TargetCosts",
            headerTooltip: "Target Costs",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.TargetCosts)
                  })
                  params.data.TargetCosts = total;
                  return total;
                }
              } else {
                return (params.data.TargetCosts);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta TC vs. Reference",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) {
                return "right-border colorTotal positive-num-color-cs"
              } else {
                return "right-border colorTotal negative-num-color-cs"
              }
            },
            field: "DeltaTCVsRef",
            tooltipField: "DeltaTCVsRef",
            headerTooltip: "Delta TC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {

                if ((params.node.data.TargetCosts == null || Number(params.node.data.TargetCosts) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaTCVsRef = Number(params.node.data.TargetCosts) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaTCVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaTCVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }

                return params.node.data.DeltaTCVsRef;
              } else {
                return null
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Forecast",
            field: "Forecast",
            tooltipField: "Forecast",
            headerTooltip: "Forecast",
            headerClass: "right-border",
            cellClass: "right-border",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.Forecast)
                  })
                  params.data.Forecast = total;
                  return total;
                }
              } else {
                return (params.data.Forecast);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta FC vs. Reference",
            field: "DeltaFCVsRef",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0)
                return "right-border colorTotal positive-num-color-cs"
              else
                return "right-border colorTotal negative-num-color-cs"
            },
            tooltipField: "DeltaFCVsRef",
            headerTooltip: "Delta FC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {
                if ((params.node.data.Forecast == null || Number(params.node.data.Forecast) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaFCVsRef = Number(params.node.data.Forecast) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaFCVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaFCVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }
                return params.node.data.DeltaFCVsRef;
              } else {
                return null
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        children: [
          {
            headerName: "Actuals",
            field: "Actuals",
            tooltipField: "Actuals",
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Actuals",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.Actuals)
                  })
                  params.data.Actuals = total;
                  return total;
                }
              } else {
                return (params.data.Actuals);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta ACT vs. Reference",
            field: "DeltaACTVsRef",
            tooltipField: "DeltaACTVsRef",
            headerTooltip: "Delta ACT vs. Reference",
            width: 100,
            editable: false,
            cellClass: (params) => {
              if (params.value > 0)
                return "colorTotal positive-num-color-cs"
              else
                return "colorTotal negative-num-color-cs"
            },

            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {
                if ((params.node.data.Actuals == null || Number(params.node.data.Actuals) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return null
                } else {
                  params.node.data.DeltaACTVsRef = Number(params.node.data.Actuals) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaACTVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaACTVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }
                return params.node.data.DeltaACTVsRef;
              } else {
                return null
              }
            }
          }
        ]
      }
    ];

    this.tarDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.tarFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onTarGridReady(params: any) {
    this.tarGridApi = params.api;
    // this.tarGridApi.setGroupHeaderHeight(30);
    this.tarGridApi.setGroupHeaderHeight(0);
    this.tarGridApi.setHeaderHeight(0);
    this.tarPinnedBottomData = createDataTar(this.totalTar(), this.isEditable);
    params.api.setPinnedBottomRowData(this.tarPinnedBottomData);
    if (this.PriceGridData) { this.refreshPinnedRowsMargin(); }  // <-- add
  }

  onGridTarCSChanged(params) {
    params.api.sizeColumnsToFit();
  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedTar(params) {
    params.api.resetRowHeights();
  }
  onColumnVisibleTar(params) {
    params.api.resetRowHeights();
  }

  onTarCellValueChangedCS(params) {
    this.tarGridApi.redrawRows();
    this.hasUnsavedChanges = true;
    //   if (params.data.configurationId      != 0) {
    let isPushed = false;
    if (this.modifiedTarCSRows.length == 0) {
      this.modifiedTarCSRows.push(params.data);
      isPushed = true;
    }
    else {
      this.modifiedTarCSRows.forEach((row, index) => {
        if (params.data.ConfigurationId
          == row.ConfigurationId && params.data.Service == row.Service
        ) {
          // row = params.data;
          // this.modifiedCSRows[index] = params.data;
          isPushed = true;
        }
      })
    }
    if (!isPushed) {
      this.modifiedTarCSRows.push(params.data);
    }
    this.refreshPinnedRowsMargin();
    // }
  }

  // calculate total for target grid for bottom "total row"
  totalTar() {
    let targetCost = 0;
    let actuals = 0;
    let forecast = 0;
    this.tarGridApi.forEachNode(function (node) {
      targetCost = Number(node.data.TargetCosts) + targetCost
      actuals = Number(node.data.Actuals) + actuals
      forecast = Number(node.data.Forecast) + forecast
    })
    return [targetCost, actuals, forecast];
  }

  loadTarPriceGridStructure() {
    this.rowClassRulesTarPrice = {
      'colorTotal': function (params) {
        let data = params.data.Description;
        // REMOVED: Price and Expected Service Costs from colorTotal
        return data === 'Delta Total Service costs to Service costs Target';
      }
    }

    this.tarPriceColumnDefs = [
      {
        headerName: "Description",
        field: "Description",
        tooltipField: "Description",
        width: 250,
        editable: false,
        hide: true,
      },
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Target Costs",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.TargetScenario?.TargetCost?.PerSystem ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            field: "TargetScenario.TargetCost.PerSystem",
            width: 100,
            valueGetter: (params) => params.data?.TargetScenario?.TargetCost?.PerSystem,
            valueSetter: (params) => {
              if (!params.data.TargetScenario) params.data.TargetScenario = {};
              if (!params.data.TargetScenario.TargetCost) params.data.TargetScenario.TargetCost = {};
              const raw = params.newValue;
              const val = (raw === null || raw === undefined) ? null : Number(String(raw).replace(/,/g, ''));
              params.data.TargetScenario.TargetCost.PerSystem = isNaN(val as any) ? null : val;
              return true;
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') return false;
              return !!params.data?.IsEditable;
            },
            valueFormatter: PriceGridValueFormatter,
            singleClickEdit: true,
          },
          {
            headerName: "Delta TC vs. Reference",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) return "right-border colorTotal positive-num-color-cs";
              return "right-border colorTotal negative-num-color-cs";
            },
            field: "DeltaTCVsRef",
            tooltipField: "DeltaTCVsRef",
            headerTooltip: "Delta TC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const tc = Number(params.data?.TargetScenario?.TargetCost?.PerSystem ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (tc === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((tc - ref) / ref) * 100;
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Forecast",
            field: "TargetScenario.Forecast.PerSystem",
            tooltipField: "Forecast",
            headerTooltip: "Forecast",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.TargetScenario?.Forecast?.PerSystem ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') return false;
              return !!params.data?.IsEditable;
            },
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => params.data?.TargetScenario?.Forecast?.PerSystem,
            valueSetter: (params) => {
              if (!params.data.TargetScenario) params.data.TargetScenario = {};
              if (!params.data.TargetScenario.Forecast) params.data.TargetScenario.Forecast = {};
              const raw = params.newValue;
              const val = (raw === null || raw === undefined) ? null : Number(String(raw).replace(/,/g, ''));
              params.data.TargetScenario.Forecast.PerSystem = isNaN(val as any) ? null : val;
              return true;
            },
            singleClickEdit: true,
          },
          {
            headerName: "Delta FC vs. Reference",
            field: "DeltaFCVsRef",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) return "right-border colorTotal positive-num-color-cs";
              return "right-border colorTotal negative-num-color-cs";
            },
            tooltipField: "DeltaFCVsRef",
            headerTooltip: "Delta FC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const fc = Number(params.data?.TargetScenario?.Forecast?.PerSystem ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (fc === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((fc - ref) / ref) * 100;
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        children: [
          {
            headerName: "Actuals",
            field: "TargetScenario.Forecast.ActualMEKs",
            tooltipField: "Actuals",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.TargetScenario?.Forecast?.ActualMEKs ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            headerTooltip: "Actuals",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') return false;
              return !!params.data?.IsEditable;
            },
            valueGetter: (params) => params.data?.TargetScenario?.Forecast?.ActualMEKs,
            valueSetter: (params) => {
              if (!params.data.TargetScenario) params.data.TargetScenario = {};
              if (!params.data.TargetScenario.Forecast) params.data.TargetScenario.Forecast = {};
              const raw = params.newValue;
              const val = (raw === null || raw === undefined) ? null : Number(String(raw).replace(/,/g, ''));
              params.data.TargetScenario.Forecast.ActualMEKs = isNaN(val as any) ? null : val;
              return true;
            },
            valueFormatter: PriceGridValueFormatter,
            singleClickEdit: true,
          },
          {
            headerName: "Delta ACT vs. Reference",
            field: "DeltaACTVsRef",
            tooltipField: "DeltaACTVsRef",
            headerTooltip: "Delta ACT vs. Reference",
            width: 100,
            editable: false,
            cellClass: (params) => {
              if (params.value > 0) return "colorTotal positive-num-color-cs";
              return "colorTotal negative-num-color-cs";
            },
            tooltipValueGetter: CurrencyCellRenderer,
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const act = Number(params.data?.TargetScenario?.Forecast?.ActualMEKs ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (act === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((act - ref) / ref) * 100;
            }
          }
        ]
      }
    ];
    this.tarPriceDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      wrapText: true,
    }
    this.rowHeight = 25;
  }

  onTarPriceGridReady(params: any) {
    this.tarPriceGridApi = params.api;
    this.tarPriceGridApi.setGroupHeaderHeight(30);

    params.api.sizeColumnsToFit();
  }

  onFirstDataRenderedTarPrice(params) {
    this.refreshPinnedRowsMargin();
    // let model = {
    //   Description: {
    //     filterType: 'set', type: 'notEqual',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // };
    // this.tarPriceGridApi.setFilterModel(model);
    // this.tarPriceGridApi.onFilterChanged();
    // this.tarPriceGridApi.redrawRows();
    // Apply filter to hide CalculateScenario row
    // params.api.setFilterModel({
    //   Description: {
    //     filterType: 'set',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // });
    // params.api.onFilterChanged();
  }

  onTarPriceCellValueChangedCS(params) {
    this.hasUnsavedChanges = true;
    this.refreshPinnedRowsMargin();
  }

  onColumnResizedTarPrice(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleTarPrice(params) {
    params.api.resetRowHeights();
  }

  onGridTarPriceCSChanged(params) {
    this.tarPriceGridApi = params.api;
    this.tarPriceGridApi.sizeColumnsToFit();
  }

  loadOptAGridStructure() {
    this.rowClassRulesOptA = {
      'colorTotal': function (params) {
        let data = params.data.Service;
        return data === 'Total Service Costs';
      }
    }

    this.optAColumnDefs = [
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Target Costs",
            headerClass: "right-border",
            cellClass: "right-border",
            field: "TargetCosts",
            tooltipField: "TargetCosts",
            headerTooltip: "Target Costs",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.TargetCosts)
                  })
                  params.data.TargetCosts = total;
                  return total;
                }
              } else {
                return (params.data.TargetCosts);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta TC vs. Reference",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0)
                return "right-border colorTotal positive-num-color-cs"
              else
                return "right-border colorTotal negative-num-color-cs"
            },
            field: "DeltaTCVsRef",
            tooltipField: "DeltaTCVsRef",
            headerTooltip: "Delta TC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {

                if ((params.node.data.TargetCosts == null || Number(params.node.data.TargetCosts) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaTCVsRef = Number(params.node.data.TargetCosts) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaTCVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaTCVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }

                return params.node.data.DeltaTCVsRef;
              } else {
                return null
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Forecast",
            field: "Forecast",
            tooltipField: "Forecast",
            headerTooltip: "Forecast",
            headerClass: "right-border",
            cellClass: "right-border",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.Forecast)
                  })
                  params.data.Forecast = total;
                  return total;
                }
              } else {
                return (params.data.Forecast);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta FC vs. Reference",
            field: "DeltaFCVsRef",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0)
                return "right-border colorTotal positive-num-color-cs"
              else
                return "right-border colorTotal negative-num-color-cs"
            },
            tooltipField: "DeltaFCVsRef",
            headerTooltip: "Delta FC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {
                if ((params.node.data.Forecast == null || Number(params.node.data.Forecast) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaFCVsRef = Number(params.node.data.Forecast) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaFCVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaFCVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }
                return params.node.data.DeltaFCVsRef;
              } else {
                return null
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        children: [
          {
            headerName: "Actuals",
            field: "Actuals",
            tooltipField: "Actuals",
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Actuals",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.Actuals)
                  })
                  params.data.Actuals = total;
                  return total;
                }
              } else {
                return (params.data.Actuals);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta ACT vs. Reference",
            field: "DeltaACTVsRef",
            tooltipField: "DeltaACTVsRef",
            headerTooltip: "Delta ACT vs. Reference",
            width: 100,
            editable: false,
            cellClass: (params) => {
              if (params.value > 0)
                return "colorTotal positive-num-color-cs"
              else
                return "colorTotal negative-num-color-cs"
            },
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {
                if ((params.node.data.Actuals == null || Number(params.node.data.Actuals) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaACTVsRef = Number(params.node.data.Actuals) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaACTVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaACTVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }
                return params.node.data.DeltaACTVsRef;
              } else {
                return null
              }
            }
          }
        ]
      }
    ];

    this.optADefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.optAFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onOptAGridReady(params: any) {
    this.optAGridApi = params.api;
    // this.optAGridApi.setGroupHeaderHeight(30);
    this.optAGridApi.setGroupHeaderHeight(0);
    this.optAGridApi.setHeaderHeight(0);
    this.optAPinnedBottomData = createDataOptA(this.totalOptA(), this.isEditable);
    params.api.setPinnedBottomRowData(this.optAPinnedBottomData);
    if (this.PriceGridData) { this.refreshPinnedRowsMargin(); }  // <-- add
  }

  onGridOptACSChanged(params) {
    params.api.sizeColumnsToFit();
  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedOptA(params) {
    params.api.resetRowHeights();
  }
  onColumnVisibleOptA(params) {
    params.api.resetRowHeights();
  }

  onOptACellValueChangedCS(params) {
    this.optAGridApi.redrawRows();
    this.hasUnsavedChanges = true;
    let isPushed = false;
    if (this.modifiedOptACSRows.length == 0) {
      this.modifiedOptACSRows.push(params.data);
      isPushed = true;
    }
    else {
      this.modifiedOptACSRows.forEach((row, index) => {
        if (params.data.ConfigurationId
          == row.ConfigurationId && params.data.CSId == row.CSId && params.data.Service == row.Service
        ) {
          isPushed = true;
        }
      })
    }
    if (!isPushed) {
      this.modifiedOptACSRows.push(params.data);
    }
    this.refreshPinnedRowsMargin();
  }

  // calculate total for option A grid for bottom "total row"
  totalOptA() {
    let targetCost = 0;
    let actuals = 0;
    let forecast = 0;
    this.optAGridApi.forEachNode(function (node) {
      targetCost = Number(node.data.TargetCosts) + targetCost
      actuals = Number(node.data.Actuals) + actuals
      forecast = Number(node.data.Forecast) + forecast
    })
    return [targetCost, actuals, forecast];
  }

  loadOptAPriceGridStructure() {
    this.rowClassRulesOptAPrice = {
      'colorTotal': function (params) {
        return params.data.Description === 'Delta Total Service costs to Service costs Target';
      }
    }
    this.optAPriceColumnDefs = [
      {
        headerName: "Description",
        field: "Description",
        tooltipField: "Description",
        hide: true,
        width: 250,
        editable: false,
      },
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Target Costs",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionA?.TargetCost?.PerSystem ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            field: "OptionA.TargetCost.PerSystem",
            width: 100,
            valueGetter: (params) => params.data?.OptionA?.TargetCost?.PerSystem,
            valueSetter: (params) => {
              if (!params.data.OptionA) params.data.OptionA = {};
              if (!params.data.OptionA.TargetCost) params.data.OptionA.TargetCost = {};
              const raw = params.newValue;
              const val = (raw === null || raw === undefined) ? null : Number(String(raw).replace(/,/g, ''));
              params.data.OptionA.TargetCost.PerSystem = isNaN(val as any) ? null : val;
              return true;
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') return false;
              return !!params.data?.IsEditable;
            },
            valueFormatter: PriceGridValueFormatter,
            singleClickEdit: true,
          },
          {
            headerName: "Delta TC vs. Reference",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) return "right-border colorTotal positive-num-color-cs";
              return "right-border colorTotal negative-num-color-cs";
            },
            field: "DeltaTCVsRef",
            tooltipField: "DeltaTCVsRef",
            headerTooltip: "Delta TC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const tc = Number(params.data?.OptionA?.TargetCost?.PerSystem ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (tc === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((tc - ref) / ref) * 100;
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Forecast",
            field: "OptionA.Forecast.PerSystem",
            tooltipField: "Forecast",
            headerTooltip: "Forecast",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionA?.Forecast?.PerSystem ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') return false;
              return !!params.data?.IsEditable;
            },
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => params.data?.OptionA?.Forecast?.PerSystem,
            valueSetter: (params) => {
              if (!params.data.OptionA) params.data.OptionA = {};
              if (!params.data.OptionA.Forecast) params.data.OptionA.Forecast = {};
              const raw = params.newValue;
              const val = (raw === null || raw === undefined) ? null : Number(String(raw).replace(/,/g, ''));
              params.data.OptionA.Forecast.PerSystem = isNaN(val as any) ? null : val;
              return true;
            },
            singleClickEdit: true,
          },
          {
            headerName: "Delta FC vs. Reference",
            field: "DeltaFCVsRef",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0) return "right-border colorTotal positive-num-color-cs";
              return "right-border colorTotal negative-num-color-cs";
            },
            tooltipField: "DeltaFCVsRef",
            headerTooltip: "Delta FC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const fc = Number(params.data?.OptionA?.Forecast?.PerSystem ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (fc === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((fc - ref) / ref) * 100;
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        children: [
          {
            headerName: "Actuals",
            field: "OptionA.Forecast.ActualMEKs",
            tooltipField: "Actuals",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionA?.Forecast?.ActualMEKs ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            headerTooltip: "Actuals",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') return false;
              return !!params.data?.IsEditable;
            },
            valueGetter: (params) => params.data?.OptionA?.Forecast?.ActualMEKs,
            valueSetter: (params) => {
              if (!params.data.OptionA) params.data.OptionA = {};
              if (!params.data.OptionA.Forecast) params.data.OptionA.Forecast = {};
              const raw = params.newValue;
              const val = (raw === null || raw === undefined) ? null : Number(String(raw).replace(/,/g, ''));
              params.data.OptionA.Forecast.ActualMEKs = isNaN(val as any) ? null : val;
              return true;
            },
            valueFormatter: PriceGridValueFormatter,
            singleClickEdit: true,
          },
          {
            headerName: "Delta ACT vs. Reference",
            field: "DeltaACTVsRef",
            tooltipField: "DeltaACTVsRef",
            headerTooltip: "Delta ACT vs. Reference",
            width: 100,
            editable: false,
            cellClass: (params) => {
              if (params.value > 0) return "colorTotal positive-num-color-cs";
              return "colorTotal negative-num-color-cs";
            },
            tooltipValueGetter: CurrencyCellRenderer,
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const act = Number(params.data?.OptionA?.Forecast?.ActualMEKs ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (act === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((act - ref) / ref) * 100;
            }
          }
        ]
      }
    ];
    this.optAPriceDefaultColDef = { suppressMovable: true, sortable: false, wrapText: true };
    this.rowHeight = 25;
  }

  onOptAPriceGridReady(params: any) {
    this.optAPriceGridApi = params.api;
    // params.api.setHeaderHeight(0);
    this.optAPriceGridApi.setGroupHeaderHeight(30);

    params.api.sizeColumnsToFit();
  }

  onFirstDataRenderedOptAPrice(params) {
    this.refreshPinnedRowsMargin();
    // let model = {
    //   Description: {
    //     filterType: 'set', type: 'notEqual',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // };
    // this.tarPriceGridApi.setFilterModel(model);
    // this.tarPriceGridApi.onFilterChanged();
    // this.tarPriceGridApi.redrawRows();
    // Apply filter to hide CalculateScenario row
    // params.api.setFilterModel({
    //   Description: {
    //     filterType: 'set',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // });
    // params.api.onFilterChanged();
  }

  onOptAPriceCellValueChangedCS(params) {
    this.hasUnsavedChanges = true;
    this.refreshPinnedRowsMargin();
  }

  onColumnResizedOptAPrice(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleOptAPrice(params) {
    params.api.resetRowHeights();
  }

  onGridOptAPriceCSChanged(params) {
    this.optAPriceGridApi = params.api;
    this.optAPriceGridApi.sizeColumnsToFit();
  }

  loadOptBGridStructure() {
    this.rowClassRulesOptB = {
      'colorTotal': function (params) {
        let data = params.data.Service;
        return data === 'Total Service Costs';
      }
    }

    this.optBColumnDefs = [
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Target Costs",
            headerClass: "right-border",
            cellClass: "right-border",
            field: "TargetCosts",
            tooltipField: "TargetCosts",
            headerTooltip: "Target Costs",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.TargetCosts)
                  })
                  params.data.TargetCosts = total;
                  return total;
                }
              } else {
                return (params.data.TargetCosts);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta TC vs. Reference",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0)
                return "right-border colorTotal positive-num-color-cs"
              else
                return "right-border colorTotal negative-num-color-cs"
            },
            field: "DeltaTCVsRef",
            tooltipField: "DeltaTCVsRef",
            headerTooltip: "Delta TC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {

                if ((params.node.data.TargetCosts == null || Number(params.node.data.TargetCosts) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaTCVsRef = Number(params.node.data.TargetCosts) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaTCVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaTCVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }

                return params.node.data.DeltaTCVsRef;
              } else {
                return null
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Forecast",
            field: "Forecast",
            tooltipField: "Forecast",
            headerTooltip: "Forecast",
            headerClass: "right-border",
            cellClass: "right-border",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.Forecast)
                  })
                  params.data.Forecast = total;
                  return total;
                }
              } else {
                return (params.data.Forecast);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta FC vs. Reference",
            field: "DeltaFCVsRef",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0)
                return "right-border colorTotal positive-num-color-cs"
              else
                return "right-border colorTotal negative-num-color-cs"
            },
            tooltipField: "DeltaFCVsRef",
            headerTooltip: "Delta FC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {
                if ((params.node.data.Forecast == null || Number(params.node.data.Forecast) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaFCVsRef = Number(params.node.data.Forecast) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaFCVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaFCVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }
                return params.node.data.DeltaFCVsRef;
              } else {
                return null
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        children: [
          {
            headerName: "Actuals",
            field: "Actuals",
            tooltipField: "Actuals",
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Actuals",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.Actuals)
                  })
                  params.data.Actuals = total;
                  return total;
                }
              } else {
                return (params.data.Actuals);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta ACT vs. Reference",
            field: "DeltaACTVsRef",
            tooltipField: "DeltaACTVsRef",
            headerTooltip: "Delta ACT vs. Reference",
            width: 100,
            editable: false,
            cellClass: (params) => {
              if (params.value > 0)
                return "colorTotal positive-num-color-cs"
              else
                return "colorTotal negative-num-color-cs"
            },
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {
                if ((params.node.data.Actuals == null || Number(params.node.data.Actuals) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaACTVsRef = Number(params.node.data.Actuals) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaACTVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaACTVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }
                return params.node.data.DeltaACTVsRef;
              } else {
                return null
              }
            }
          }
        ]
      }
    ];

    this.optBDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.optBFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onOptBGridReady(params: any) {
    this.optBGridApi = params.api;
    // this.optBGridApi.setGroupHeaderHeight(30);
    this.optBGridApi.setGroupHeaderHeight(0);
    this.optBGridApi.setHeaderHeight(0);
    this.optBPinnedBottomData = createDataOptB(this.totalOptB(), this.isEditable);
    params.api.setPinnedBottomRowData(this.optBPinnedBottomData);
    if (this.PriceGridData) { this.refreshPinnedRowsMargin(); }  // <-- add
  }

  onGridOptBCSChanged(params) {
    params.api.sizeColumnsToFit();
  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedOptB(params) {
    params.api.resetRowHeights();
  }
  onColumnVisibleOptB(params) {
    params.api.resetRowHeights();
  }

  onOptBCellValueChangedCS(params) {
    this.optBGridApi.redrawRows();
    this.hasUnsavedChanges = true;
    let isPushed = false;
    if (this.modifiedOptBCSRows.length == 0) {
      this.modifiedOptBCSRows.push(params.data);
      isPushed = true;
    }
    else {
      this.modifiedOptBCSRows.forEach((row, index) => {
        if (params.data.ConfigurationId
          == row.ConfigurationId && params.data.CSId == row.CSId && params.data.Service == row.Service
        ) {
          isPushed = true;
        }
      })
    }
    if (!isPushed) {
      this.modifiedOptBCSRows.push(params.data);
    }
    this.refreshPinnedRowsMargin();
  }

  // calculate total for option B grid for bottom "total row"
  totalOptB() {
    let targetCost = 0;
    let actuals = 0;
    let forecast = 0;
    this.optBGridApi.forEachNode(function (node) {
      targetCost = Number(node.data.TargetCosts) + targetCost
      actuals = Number(node.data.Actuals) + actuals
      forecast = Number(node.data.Forecast) + forecast
    })
    return [targetCost, actuals, forecast];
  }

  loadOptBPriceGridStructure() {
    this.rowClassRulesOptBPrice = {
      'colorTotal': function (params) {
        return params.data.Description === 'Delta Total Service costs to Service costs Target';
      }
    }
    this.optBPriceColumnDefs = [
      { headerName: "Description", field: "Description", hide: true, width: 250, editable: false },
      {
        headerName: "Target Costs", headerTooltip: "Target Costs", headerClass: "right-border",
        children: [
          {
            headerName: "Target Costs", headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionB?.TargetCost?.PerSystem ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            field: "OptionB.TargetCost.PerSystem", width: 100,
            valueGetter: (params) => params.data?.OptionB?.TargetCost?.PerSystem,
            valueSetter: (params) => {
              if (!params.data.OptionB) params.data.OptionB = {};
              if (!params.data.OptionB.TargetCost) params.data.OptionB.TargetCost = {};
              const val = (params.newValue === null || params.newValue === undefined) ? null : Number(String(params.newValue).replace(/,/g, ''));
              params.data.OptionB.TargetCost.PerSystem = isNaN(val as any) ? null : val;
              return true;
            },
            cellEditor: 'doublingEditor',
            editable: (params) => params.data?.Description !== 'Delta Total Service costs to Service costs Target' && !!params.data?.IsEditable,
            valueFormatter: PriceGridValueFormatter, singleClickEdit: true,
          },
          {
            headerName: "Delta TC vs. Reference", headerClass: "right-border",
            cellClass: (params) => params.value > 0 ? "right-border colorTotal positive-num-color-cs" : "right-border colorTotal negative-num-color-cs",
            field: "DeltaTCVsRef", width: 100, editable: false,
            tooltipValueGetter: CurrencyCellRenderer, valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const tc = Number(params.data?.OptionB?.TargetCost?.PerSystem ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (tc === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((tc - ref) / ref) * 100;
            }
          }
        ]
      },
      {
        headerName: "Forecast", headerTooltip: "Forecast", headerClass: "right-border",
        children: [
          {
            headerName: "Forecast", field: "OptionB.Forecast.PerSystem",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionB?.Forecast?.PerSystem ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            width: 100, cellEditor: 'doublingEditor',
            editable: (params) => params.data?.Description !== 'Delta Total Service costs to Service costs Target' && !!params.data?.IsEditable,
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => params.data?.OptionB?.Forecast?.PerSystem,
            valueSetter: (params) => {
              if (!params.data.OptionB) params.data.OptionB = {};
              if (!params.data.OptionB.Forecast) params.data.OptionB.Forecast = {};
              const val = (params.newValue === null || params.newValue === undefined) ? null : Number(String(params.newValue).replace(/,/g, ''));
              params.data.OptionB.Forecast.PerSystem = isNaN(val as any) ? null : val;
              return true;
            },
            singleClickEdit: true,
          },
          {
            headerName: "Delta FC vs. Reference", field: "DeltaFCVsRef", headerClass: "right-border",
            cellClass: (params) => params.value > 0 ? "right-border colorTotal positive-num-color-cs" : "right-border colorTotal negative-num-color-cs",
            width: 100, editable: false,
            tooltipValueGetter: CurrencyCellRenderer, valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const fc = Number(params.data?.OptionB?.Forecast?.PerSystem ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (fc === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((fc - ref) / ref) * 100;
            }
          }
        ]
      },
      {
        headerName: "Actuals", headerTooltip: "Actuals",
        children: [
          {
            headerName: "Actuals", field: "OptionB.Forecast.ActualMEKs", headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionB?.Forecast?.ActualMEKs ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            width: 100, cellEditor: 'doublingEditor',
            editable: (params) => params.data?.Description !== 'Delta Total Service costs to Service costs Target' && !!params.data?.IsEditable,
            valueGetter: (params) => params.data?.OptionB?.Forecast?.ActualMEKs,
            valueSetter: (params) => {
              if (!params.data.OptionB) params.data.OptionB = {};
              if (!params.data.OptionB.Forecast) params.data.OptionB.Forecast = {};
              const val = (params.newValue === null || params.newValue === undefined) ? null : Number(String(params.newValue).replace(/,/g, ''));
              params.data.OptionB.Forecast.ActualMEKs = isNaN(val as any) ? null : val;
              return true;
            },
            valueFormatter: PriceGridValueFormatter, singleClickEdit: true,
          },
          {
            headerName: "Delta ACT vs. Reference", field: "DeltaACTVsRef", width: 100, editable: false,
            cellClass: (params) => params.value > 0 ? "colorTotal positive-num-color-cs" : "colorTotal negative-num-color-cs",
            tooltipValueGetter: CurrencyCellRenderer, valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const act = Number(params.data?.OptionB?.Forecast?.ActualMEKs ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (act === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((act - ref) / ref) * 100;
            }
          }
        ]
      }
    ];
    this.optBPriceDefaultColDef = { suppressMovable: true, sortable: false, wrapText: true };
    this.rowHeight = 25;
  }

  onOptBPriceGridReady(params: any) {
    this.optBPriceGridApi = params.api;
    // params.api.setHeaderHeight(0);
    this.optBPriceGridApi.setGroupHeaderHeight(30);

    params.api.sizeColumnsToFit();
  }

  onFirstDataRenderedOptBPrice(params) {
    this.refreshPinnedRowsMargin();
    // let model = {
    //   Description: {
    //     filterType: 'set', type: 'notEqual',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // };
    // this.tarPriceGridApi.setFilterModel(model);
    // this.tarPriceGridApi.onFilterChanged();
    // this.tarPriceGridApi.redrawRows();
    // Apply filter to hide CalculateScenario row
    // params.api.setFilterModel({
    //   Description: {
    //     filterType: 'set',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // });
    // params.api.onFilterChanged();
  }

  onOptBPriceCellValueChangedCS(params) {
    this.hasUnsavedChanges = true;
    this.refreshPinnedRowsMargin();
  }

  onColumnResizedOptBPrice(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleOptBPrice(params) {
    params.api.resetRowHeights();
  }

  onGridOptBPriceCSChanged(params) {
    this.optBPriceGridApi = params.api;
    this.optBPriceGridApi.sizeColumnsToFit();
  }

  loadOptCGridStructure() {
    this.rowClassRulesOptC = {
      'colorTotal': function (params) {
        let data = params.data.Service;
        return data === 'Total Service Costs';
      }
    }

    this.optCColumnDefs = [
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Target Costs",
            headerClass: "right-border",
            cellClass: "right-border",
            field: "TargetCosts",
            tooltipField: "TargetCosts",
            headerTooltip: "Target Costs",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.TargetCosts)
                  })
                  params.data.TargetCosts = total;
                  return total;
                }
              } else {
                return (params.data.TargetCosts);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta TC vs. Reference",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0)
                return "right-border colorTotal positive-num-color-cs"
              else
                return "right-border colorTotal negative-num-color-cs"
            },
            field: "DeltaTCVsRef",
            tooltipField: "DeltaTCVsRef",
            headerTooltip: "Delta TC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {

                if ((params.node.data.TargetCosts == null || Number(params.node.data.TargetCosts) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaTCVsRef = Number(params.node.data.TargetCosts) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaTCVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaTCVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }

                return params.node.data.DeltaTCVsRef;
              } else {
                return null
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Forecast",
            field: "Forecast",
            tooltipField: "Forecast",
            headerTooltip: "Forecast",
            headerClass: "right-border",
            cellClass: "right-border",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.Forecast)
                  })
                  params.data.Forecast = total;
                  return total;
                }
              } else {
                return (params.data.Forecast);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta FC vs. Reference",
            field: "DeltaFCVsRef",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value > 0)
                return "right-border colorTotal positive-num-color-cs"
              else
                return "right-border colorTotal negative-num-color-cs"
            },
            tooltipField: "DeltaFCVsRef",
            headerTooltip: "Delta FC vs. Reference",
            width: 100,
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {
                if ((params.node.data.Forecast == null || Number(params.node.data.Forecast) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaFCVsRef = Number(params.node.data.Forecast) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaFCVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaFCVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }
                return params.node.data.DeltaFCVsRef;
              } else {
                return null
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        children: [
          {
            headerName: "Actuals",
            field: "Actuals",
            tooltipField: "Actuals",
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Actuals",
            width: 100,
            tooltipValueGetter: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service === 'Total Service Costs') {
                let total = 0;

                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    total += Number(node.data.Actuals)
                  })
                  params.data.Actuals = total;
                  return total;
                }
              } else {
                return (params.data.Actuals);
              }
            },
            cellEditor: 'doublingEditor',
            editable: (params) => {
              if (params.node.data.Service === 'Total Service Costs') {
                return false;
              }
              else {
                return params.data.IsEditable;
              }
            },
            cellRenderer: CurrencyCellRenderer,
            singleClickEdit: true,
          },
          {
            headerName: "Delta ACT vs. Reference",
            field: "DeltaACTVsRef",
            tooltipField: "DeltaACTVsRef",
            headerTooltip: "Delta ACT vs. Reference",
            width: 100,
            editable: false,
            cellClass: (params) => {
              if (params.value > 0)
                return "colorTotal positive-num-color-cs"
              else
                return "colorTotal negative-num-color-cs"
            },
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.Service != 'Total Service Costs' && params.node.data.Service != 'CCR') {
                if ((params.node.data.Actuals == null || Number(params.node.data.Actuals) == 0) && (params.node.data.ReferenceCost == null || Number(params.node.data.ReferenceCost) == 0)) {
                  return 0
                } else {
                  params.node.data.DeltaACTVsRef = Number(params.node.data.Actuals) - Number(params.node.data.ReferenceCost)
                  params.node.data.DeltaACTVsRef = (Number(params.node.data.ReferenceCost) == 0) ? 100 : (Number(params.node.data.DeltaACTVsRef) / Number(params.node.data.ReferenceCost)) * 100
                }
                return params.node.data.DeltaACTVsRef;
              } else {
                return null
              }
            }
          }
        ]
      }
    ];

    this.optCDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.optCFrameworkComponents = {
      doublingEditor: DoublingEditorComponent,
    };
  }

  onOptCGridReady(params: any) {
    this.optCGridApi = params.api;
    // this.optCGridApi.setGroupHeaderHeight(30);
    this.optCGridApi.setGroupHeaderHeight(0);
    this.optCGridApi.setHeaderHeight(0);
    this.optCPinnedBottomData = createDataOptC(this.totalOptC(), this.isEditable);
    params.api.setPinnedBottomRowData(this.optCPinnedBottomData);
    if (this.PriceGridData) { this.refreshPinnedRowsMargin(); }  // <-- add
  }

  onGridOptCCSChanged(params) {
    params.api.sizeColumnsToFit();
  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedOptC(params) {
    params.api.resetRowHeights();
  }
  onColumnVisibleOptC(params) {
    params.api.resetRowHeights();
  }

  onOptCCellValueChangedCS(params) {
    this.optCGridApi.redrawRows();
    this.hasUnsavedChanges = true;
    let isPushed = false;
    if (this.modifiedOptCCSRows.length == 0) {
      this.modifiedOptCCSRows.push(params.data);
      isPushed = true;
    }
    else {
      this.modifiedOptCCSRows.forEach((row, index) => {
        if (params.data.ConfigurationId
          == row.ConfigurationId && params.data.CSId == row.CSId && params.data.Service == row.Service
        ) {
          isPushed = true;
        }
      })
    }
    if (!isPushed) {
      this.modifiedOptCCSRows.push(params.data);
    }
    this.refreshPinnedRowsMargin();
  }

  // calculate total for option C grid for bottom "total row"
  totalOptC() {
    let targetCost = 0;
    let actuals = 0;
    let forecast = 0;
    this.optCGridApi.forEachNode(function (node) {
      targetCost = Number(node.data.TargetCosts) + targetCost
      actuals = Number(node.data.Actuals) + actuals
      forecast = Number(node.data.Forecast) + forecast
    })
    return [targetCost, actuals, forecast];
  }

  loadOptCPriceGridStructure() {
    this.rowClassRulesOptCPrice = {
      'colorTotal': function (params) {
        return params.data.Description === 'Delta Total Service costs to Service costs Target';
      }
    }
    this.optCPriceColumnDefs = [
      { headerName: "Description", field: "Description", hide: true, width: 250, editable: false },
      {
        headerName: "Target Costs", headerTooltip: "Target Costs", headerClass: "right-border",
        children: [
          {
            headerName: "Target Costs", headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionC?.TargetCost?.PerSystem ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            field: "OptionC.TargetCost.PerSystem", width: 100,
            valueGetter: (params) => params.data?.OptionC?.TargetCost?.PerSystem,
            valueSetter: (params) => {
              if (!params.data.OptionC) params.data.OptionC = {};
              if (!params.data.OptionC.TargetCost) params.data.OptionC.TargetCost = {};
              const val = (params.newValue === null || params.newValue === undefined) ? null : Number(String(params.newValue).replace(/,/g, ''));
              params.data.OptionC.TargetCost.PerSystem = isNaN(val as any) ? null : val;
              return true;
            },
            cellEditor: 'doublingEditor',
            editable: (params) => params.data?.Description !== 'Delta Total Service costs to Service costs Target' && !!params.data?.IsEditable,
            valueFormatter: PriceGridValueFormatter, singleClickEdit: true,
          },
          {
            headerName: "Delta TC vs. Reference", headerClass: "right-border",
            cellClass: (params) => params.value > 0 ? "right-border colorTotal positive-num-color-cs" : "right-border colorTotal negative-num-color-cs",
            field: "DeltaTCVsRef", width: 100, editable: false,
            tooltipValueGetter: CurrencyCellRenderer, valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const tc = Number(params.data?.OptionC?.TargetCost?.PerSystem ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (tc === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((tc - ref) / ref) * 100;
            }
          }
        ]
      },
      {
        headerName: "Forecast", headerTooltip: "Forecast", headerClass: "right-border",
        children: [
          {
            headerName: "Forecast", field: "OptionC.Forecast.PerSystem",
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionC?.Forecast?.PerSystem ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            width: 100, cellEditor: 'doublingEditor',
            editable: (params) => params.data?.Description !== 'Delta Total Service costs to Service costs Target' && !!params.data?.IsEditable,
            valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => params.data?.OptionC?.Forecast?.PerSystem,
            valueSetter: (params) => {
              if (!params.data.OptionC) params.data.OptionC = {};
              if (!params.data.OptionC.Forecast) params.data.OptionC.Forecast = {};
              const val = (params.newValue === null || params.newValue === undefined) ? null : Number(String(params.newValue).replace(/,/g, ''));
              params.data.OptionC.Forecast.PerSystem = isNaN(val as any) ? null : val;
              return true;
            },
            singleClickEdit: true,
          },
          {
            headerName: "Delta FC vs. Reference", field: "DeltaFCVsRef", headerClass: "right-border",
            cellClass: (params) => params.value > 0 ? "right-border colorTotal positive-num-color-cs" : "right-border colorTotal negative-num-color-cs",
            width: 100, editable: false,
            tooltipValueGetter: CurrencyCellRenderer, valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const fc = Number(params.data?.OptionC?.Forecast?.PerSystem ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (fc === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((fc - ref) / ref) * 100;
            }
          }
        ]
      },
      {
        headerName: "Actuals", headerTooltip: "Actuals",
        children: [
          {
            headerName: "Actuals", field: "OptionC.Forecast.ActualMEKs", headerClass: "right-border",
            cellClass: (params) => {
              if (params.data?.Description === 'Delta Total Service costs to Service costs Target') {
                const v = Number(params.data?.OptionC?.Forecast?.ActualMEKs ?? 0);
                return v >= 0 ? 'right-border positive-num-color-cs' : 'right-border negative-num-color-cs';
              }
              return 'right-border';
            },
            width: 100, cellEditor: 'doublingEditor',
            editable: (params) => params.data?.Description !== 'Delta Total Service costs to Service costs Target' && !!params.data?.IsEditable,
            valueGetter: (params) => params.data?.OptionC?.Forecast?.ActualMEKs,
            valueSetter: (params) => {
              if (!params.data.OptionC) params.data.OptionC = {};
              if (!params.data.OptionC.Forecast) params.data.OptionC.Forecast = {};
              const val = (params.newValue === null || params.newValue === undefined) ? null : Number(String(params.newValue).replace(/,/g, ''));
              params.data.OptionC.Forecast.ActualMEKs = isNaN(val as any) ? null : val;
              return true;
            },
            valueFormatter: PriceGridValueFormatter, singleClickEdit: true,
          },
          {
            headerName: "Delta ACT vs. Reference", field: "DeltaACTVsRef", width: 100, editable: false,
            cellClass: (params) => params.value > 0 ? "colorTotal positive-num-color-cs" : "colorTotal negative-num-color-cs",
            tooltipValueGetter: CurrencyCellRenderer, valueFormatter: PriceGridValueFormatter,
            valueGetter: (params) => {
              const act = Number(params.data?.OptionC?.Forecast?.ActualMEKs ?? 0);
              const ref = Number(params.data?.ReferenceScenario?.PerSystem ?? 0);
              if (act === 0 && ref === 0) return 0;
              return ref === 0 ? 100 : ((act - ref) / ref) * 100;
            }
          }
        ]
      }
    ];
    this.optCPriceDefaultColDef = { suppressMovable: true, sortable: false, wrapText: true };
    this.rowHeight = 25;
  }

  onOptCPriceGridReady(params: any) {
    this.optCPriceGridApi = params.api;
    // params.api.setHeaderHeight(0);
    this.optCPriceGridApi.setGroupHeaderHeight(30);

    params.api.sizeColumnsToFit();
  }

  onFirstDataRenderedOptCPrice(params) {
    this.refreshPinnedRowsMargin();
    // let model = {
    //   Description: {
    //     filterType: 'set', type: 'notEqual',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // };
    // this.tarPriceGridApi.setFilterModel(model);
    // this.tarPriceGridApi.onFilterChanged();
    // this.tarPriceGridApi.redrawRows();
    // Apply filter to hide CalculateScenario row
    // params.api.setFilterModel({
    //   Description: {
    //     filterType: 'set',
    //     values: ['Price', 'Expected Margin in %', 'Expected Service Costs']
    //   }
    // });
    // params.api.onFilterChanged();
  }

  onOptCPriceCellValueChangedCS(params) {
    this.hasUnsavedChanges = true;
    this.refreshPinnedRowsMargin();
  }

  onColumnResizedOptCPrice(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleOptCPrice(params) {
    params.api.resetRowHeights();
  }

  onGridOptCPriceCSChanged(params) {
    this.optCPriceGridApi = params.api;
    this.optCPriceGridApi.sizeColumnsToFit();
  }

  onRefTitleRawChange(title: string) {
    if (title != null)
      this.hasUnsavedChanges = true;
  }
  onTarTitleRawChange(title: string) {
    if (title != null)
      this.hasUnsavedChanges = true;
  }
  onOptATitleRawChange(title: string) {
    if (title != null)
      this.hasUnsavedChanges = true;
  }
  onOptBTitleRawChange(title: string) {
    if (title != null)
      this.hasUnsavedChanges = true;
  }
  onOptCTitleRawChange(title: string) {
    if (title != null)
      this.hasUnsavedChanges = true;
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  onClickCancel() {
    this.hasUnsavedChanges = false;
    this.router.navigate(["/tc-manageProject"]);
  }

  onClickBack() {
    this.menuService.onClickNextAndBack("back");
  }

  onClickNext() {
    this.menuService.onClickNextAndBack("next");
  }



  submit(event?: any) {
    if (!this.hasUnsavedChanges && event == undefined) {
      return true
    }
    let response = null;
    this.submitted = true;

    let sendData = this.sendData();
    response = this.CstargetcostingService.InsertupdateCScost(sendData).toPromise().
      then((res) => {
        this.submitResponse = res;
        let successCode = this.submitResponse.StatusCode;
        let errorCode = this.submitResponse.Data.ErrorCode;
        let errorMsgeFromBack = this.submitResponse.Data.Message;
        if (successCode == 200) {
          if (errorCode == 0) {
            this.hasUnsavedChanges = false;
            let dataSaveMessage = serverMessage.dataSaveMessage;
            this.toast.notify(dataSaveMessage, "success");
            if (event != undefined) {
              //  this.localStorageService.remove("configuration");
              this.hasUnsavedChanges = false;
              this.router.navigate(['/tc-manageProject'])
            }
            return true;
          }
          else {
            //Show errorCode and errorMessage in the UI
            let errorContainer = [
              { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
              { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
            ]
            this.openAlertDialog(errorContainer)
            this.submitted = false;
            return false;
          }
        }
        else {
          let errorContainer = [
            { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
            { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
          ]
          this.openAlertDialog(errorContainer)
          this.submitted = false;
          return false;
        }
      },
        (error) => {
          this.submitted = false;
          this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
          return false;
        })

    return response;

  }
  sendData() {
    let refObj: Cscost[] = this.csMasterData;

    this.refreshDeltaRow();

    let CSSimulationpriceData = this.PriceGridData;
    CSSimulationpriceData.forEach(priceRow => {
      if (priceRow.Id == 0) {
        // priceRow.IsActive = true;
        priceRow.CreatedBy = this.userInOrg.UserId;
        priceRow.CreatedOn = new Date();
      } else {
        // priceRow.IsActive = true;
        priceRow.ModifiedBy = this.userInOrg.UserId;
        priceRow.ModifiedOn = new Date();
      }
    });

    refObj.forEach(cs => {
      cs.IsActive = true;
      cs.ReferenceScenario.ScenarioTitle = this.refTitle;
      cs.TargetScenario.ScenarioTitle = this.tarTitle;
      if (cs.OptionA != null) cs.OptionA.ScenarioTitle = this.optATitle;
      if (cs.OptionB != null) cs.OptionB.ScenarioTitle = this.optBTitle;
      if (cs.OptionC != null) cs.OptionC.ScenarioTitle = this.optCTitle;

      if (cs.CSId == 0) {
        cs.CreatedBy = this.userInOrg.UserId;
        cs.CreatedOn = new Date();
      } else {
        cs.ModifiedBy = this.userInOrg.UserId;
        cs.ModifiedOn = new Date();
      }
      if (cs.Service == "Margin in %") {
        return;
      }

      let referenceRow = this.modifiedRefCSRows.find(x => x.Service == cs.Service);
      if (referenceRow) {
        cs.ReferenceScenario.CSId = referenceRow.CSId;
        cs.ReferenceScenario.Cost = Number(referenceRow.Costs);
      }

      let targetRow = this.modifiedTarCSRows.find(x => x.Service == cs.Service);
      if (targetRow) {
        cs.TargetScenario.TargetCost = {
          CSId: targetRow.CSIdTargetCost,
          Cost: Number(targetRow.TargetCosts),
          DeltaTCvsRefrence: Number(targetRow.DeltaTCVsRef)
        }

        cs.TargetScenario.ForeCast = {
          CSId: targetRow.CSIdForecast,
          Cost: Number(targetRow.Forecast),
          DeltaFCvsReference: Number(targetRow.DeltaFCVsRef)
        }

        cs.TargetScenario.Actuals = {
          CSId: targetRow.CSIdActuals,
          Cost: Number(targetRow.Actuals),
          DeltaTCvsAct: Number(targetRow.DeltaACTVsRef)
        }
      } else {
        if (cs.TargetScenario.TargetCost == null) {
          cs.TargetScenario.TargetCost = {
            CSId: 0,
            Cost: 0,
            DeltaTCvsRefrence: 0
          }
        }
        if (cs.TargetScenario.ForeCast == null) {
          cs.TargetScenario.ForeCast = {
            CSId: 0,
            Cost: 0,
            DeltaFCvsReference: 0,
          }
        }
        if (cs.TargetScenario.Actuals == null) {
          cs.TargetScenario.Actuals = {
            CSId: 0,
            Cost: 0,
            DeltaTCvsAct: 0,
          }
        }
      }

      if (this.optAVisible) {
        let optARow = this.modifiedOptACSRows.find(x => x.Service == cs.Service);
        if (optARow) {
          let TargetCost = {
            CSId: optARow.CSIdTargetCost,
            Cost: Number(optARow.TargetCosts),
            DeltaTCvsRefrence: Number(optARow.DeltaTCVsRef)
          }

          let ForeCast = {
            CSId: optARow.CSIdForecast,
            Cost: Number(optARow.Forecast),
            DeltaFCvsReference: Number(optARow.DeltaFCVsRef)
          }

          let Actuals = {
            CSId: optARow.CSIdActuals,
            Cost: Number(optARow.Actuals),
            DeltaTCvsAct: Number(optARow.DeltaACTVsRef)
          }
          cs.OptionA = { TargetCost: TargetCost, ForeCast: ForeCast, Actuals: Actuals, ScenarioTitle: this.optATitle };
        } else {
          if (cs.OptionA == null) {
            let TargetCost = {
              CSId: 0,
              Cost: 0,
              DeltaTCvsRefrence: 0
            }
            let ForeCast = {
              CSId: 0,
              Cost: 0,
              DeltaFCvsReference: 0,
            }
            let Actuals = {
              CSId: 0,
              Cost: 0,
              DeltaTCvsAct: 0,
            }
            cs.OptionA = { TargetCost: TargetCost, ForeCast: ForeCast, Actuals: Actuals, ScenarioTitle: this.optATitle };
          }
        }
      }

      if (this.optBVisible) {
        let optBRow = this.modifiedOptBCSRows.find(x => x.Service == cs.Service);
        if (optBRow) {
          let TargetCost = {
            CSId: optBRow.CSIdTargetCost,
            Cost: Number(optBRow.TargetCosts),
            DeltaTCvsRefrence: Number(optBRow.DeltaTCVsRef)
          }

          let ForeCast = {
            CSId: optBRow.CSIdForecast,
            Cost: Number(optBRow.Forecast),
            DeltaFCvsReference: Number(optBRow.DeltaFCVsRef)
          }

          let Actuals = {
            CSId: optBRow.CSIdActuals,
            Cost: Number(optBRow.Actuals),
            DeltaTCvsAct: Number(optBRow.DeltaACTVsRef)
          }
          cs.OptionB = { TargetCost: TargetCost, ForeCast: ForeCast, Actuals: Actuals, ScenarioTitle: this.optBTitle };
        } else {
          if (cs.OptionB == null) {
            let TargetCost = {
              CSId: 0,
              Cost: 0,
              DeltaTCvsRefrence: 0
            }
            let ForeCast = {
              CSId: 0,
              Cost: 0,
              DeltaFCvsReference: 0,
            }
            let Actuals = {
              CSId: 0,
              Cost: 0,
              DeltaTCvsAct: 0,
            }
            cs.OptionB = { TargetCost: TargetCost, ForeCast: ForeCast, Actuals: Actuals, ScenarioTitle: this.optBTitle };
          }
        }
      }

      if (this.optCVisible) {
        let optCRow = this.modifiedOptCCSRows.find(x => x.Service == cs.Service);
        if (optCRow) {
          let TargetCost = {
            CSId: optCRow.CSIdTargetCost,
            Cost: Number(optCRow.TargetCosts),
            DeltaTCvsRefrence: Number(optCRow.DeltaTCVsRef)
          }

          let ForeCast = {
            CSId: optCRow.CSIdForecast,
            Cost: Number(optCRow.Forecast),
            DeltaFCvsReference: Number(optCRow.DeltaFCVsRef)
          }

          let Actuals = {
            CSId: optCRow.CSIdActuals,
            Cost: Number(optCRow.Actuals),
            DeltaTCvsAct: Number(optCRow.DeltaACTVsRef)
          }
          cs.OptionC = { TargetCost: TargetCost, ForeCast: ForeCast, Actuals: Actuals, ScenarioTitle: this.optCTitle };
        } else {
          if (cs.OptionC == null) {
            let TargetCost = {
              CSId: 0,
              Cost: 0,
              DeltaTCvsRefrence: 0
            }
            let ForeCast = {
              CSId: 0,
              Cost: 0,
              DeltaFCvsReference: 0,
            }
            let Actuals = {
              CSId: 0,
              Cost: 0,
              DeltaTCvsAct: 0,
            }
            cs.OptionC = { TargetCost: TargetCost, ForeCast: ForeCast, Actuals: Actuals, ScenarioTitle: this.optCTitle };
          }
        }
      }

      if (cs.Service == "Total Service costs") {
        let totalRefRow = this.refGridApi.getPinnedBottomRow(0).data;
        cs.ReferenceScenario.Cost = totalRefRow.Costs;

        let totalTarRow = this.tarGridApi.getPinnedBottomRow(0).data;
        cs.TargetScenario.TargetCost.Cost = totalTarRow.TargetCosts;
        cs.TargetScenario.ForeCast.Cost = totalTarRow.Forecast;
        cs.TargetScenario.Actuals.Cost = totalTarRow.Actuals;

        if (this.optAVisible) {
          let totalOptARow = this.optAGridApi.getPinnedBottomRow(0).data;
          cs.OptionA.TargetCost.Cost = totalOptARow.TargetCosts;
          cs.OptionA.ForeCast.Cost = totalOptARow.Forecast;
          cs.OptionA.Actuals.Cost = totalOptARow.Actuals;
        }
        if (this.optBVisible) {
          let totalOptBRow = this.optBGridApi.getPinnedBottomRow(0).data;
          cs.OptionB.TargetCost.Cost = totalOptBRow.TargetCosts;
          cs.OptionB.ForeCast.Cost = totalOptBRow.Forecast;
          cs.OptionB.Actuals.Cost = totalOptBRow.Actuals;
        }
        if (this.optCVisible) {
          let totalOptCRow = this.optCGridApi.getPinnedBottomRow(0).data;
          cs.OptionC.TargetCost.Cost = totalOptCRow.TargetCosts;
          cs.OptionC.ForeCast.Cost = totalOptCRow.Forecast;
          cs.OptionC.Actuals.Cost = totalOptCRow.Actuals;
        }
      }
      if (cs.Service == "CCR") {
        const refP = this.refPriceGridApi?.getPinnedBottomRow(0)?.data;
        if (refP) {
          cs.ReferenceScenario.CSId = refP.CSId ?? this.refCCRId ?? 0;
          cs.ReferenceScenario.Cost = Number(refP.ReferenceScenario?.PerSystem ?? 0);
        }

        const tarP = this.tarPriceGridApi?.getPinnedBottomRow(0)?.data;
        if (tarP) {
          cs.TargetScenario.TargetCost = { CSId: this.tarCCRTargetCostId ?? 0, Cost: Number(tarP.TargetScenario?.TargetCost?.PerSystem ?? 0), DeltaTCvsRefrence: 0 };
          cs.TargetScenario.ForeCast = { CSId: this.tarCCRForecastId ?? 0, Cost: Number(tarP.TargetScenario?.Forecast?.PerSystem ?? 0), DeltaFCvsReference: 0 };
          cs.TargetScenario.Actuals = { CSId: this.tarCCRActualsId ?? 0, Cost: Number(tarP.TargetScenario?.Forecast?.ActualMEKs ?? 0), DeltaTCvsAct: 0 };
        }

        if (this.optAVisible && this.optAPriceGridApi) {
          const p = this.optAPriceGridApi.getPinnedBottomRow(0)?.data;
          if (p) {
            cs.OptionA = {
              ...cs.OptionA, ScenarioTitle: this.optATitle,
              TargetCost: { CSId: this.optACCRTargetCostId ?? 0, Cost: Number(p.OptionA?.TargetCost?.PerSystem ?? 0), DeltaTCvsRefrence: 0 },
              ForeCast: { CSId: this.optACCRForecastId ?? 0, Cost: Number(p.OptionA?.Forecast?.PerSystem ?? 0), DeltaFCvsReference: 0 },
              Actuals: { CSId: this.optACCRActualsId ?? 0, Cost: Number(p.OptionA?.Forecast?.ActualMEKs ?? 0), DeltaTCvsAct: 0 }
            };
          }
        }

        if (this.optBVisible && this.optBPriceGridApi) {
          const p = this.optBPriceGridApi.getPinnedBottomRow(0)?.data;
          if (p) {
            cs.OptionB = {
              ...cs.OptionB, ScenarioTitle: this.optBTitle,
              TargetCost: { CSId: this.optBCCRTargetCostId ?? 0, Cost: Number(p.OptionB?.TargetCost?.PerSystem ?? 0), DeltaTCvsRefrence: 0 },
              ForeCast: { CSId: this.optBCCRForecastId ?? 0, Cost: Number(p.OptionB?.Forecast?.PerSystem ?? 0), DeltaFCvsReference: 0 },
              Actuals: { CSId: this.optBCCRActualsId ?? 0, Cost: Number(p.OptionB?.Forecast?.ActualMEKs ?? 0), DeltaTCvsAct: 0 }
            };
          }
        }

        if (this.optCVisible && this.optCPriceGridApi) {
          const p = this.optCPriceGridApi.getPinnedBottomRow(0)?.data;
          if (p) {
            cs.OptionC = {
              ...cs.OptionC, ScenarioTitle: this.optCTitle,
              TargetCost: { CSId: this.optCCCRTargetCostId ?? 0, Cost: Number(p.OptionC?.TargetCost?.PerSystem ?? 0), DeltaTCvsRefrence: 0 },
              ForeCast: { CSId: this.optCCCRForecastId ?? 0, Cost: Number(p.OptionC?.Forecast?.PerSystem ?? 0), DeltaFCvsReference: 0 },
              Actuals: { CSId: this.optCCCRActualsId ?? 0, Cost: Number(p.OptionC?.Forecast?.ActualMEKs ?? 0), DeltaTCvsAct: 0 }
            };
          }
        }
      }
    })


    return { refObj, CSSimulationpriceData };
  }

  canDeactivate() {
    return this.hasUnsavedChanges;
  }

  // Handle comment unsaved changes event from child
  onCommentUnsavedChange(hasChanges: boolean) {
    this.hasCommentUnsavedChanges = hasChanges;
  }

  // Check if comment has unsaved changes (new method)
  canDeactivateComment(): boolean {
    return this.hasCommentUnsavedChanges;
  }

  // Submit comment changes (new method)
  async submitComment(): Promise<boolean> {
    if (this.hasCommentUnsavedChanges) {
      return await this.commentBox.saveCommentIfNeeded();
    }
    return true;
  }

  getUserInfo() {
    return this.userInOrg.UserId;
  }

  getConfigurationId() {
    return this.configurationId
  }

  ngOnDestroy(): void {
    this.configSub?.unsubscribe();
    this.lockStatusSub?.unsubscribe();
    this.unsavedSub?.unsubscribe();
  }
}

function createDataRef(totalCost, isEditable) {
  return [{ Service: "Total Service Costs", Costs: totalCost }];
}

function createDataTar(total, isEditable) {
  return [{ Service: "Total Service Costs", TargetCosts: total[0], Actuals: total[1], Forecast: total[2] }];
}

function createDataOptA(total, isEditable) {
  return [{ Service: "Total Service Costs", TargetCosts: total[0], Actuals: total[1], Forecast: total[2] }];
}

function createDataOptB(total, isEditable) {
  return [{ Service: "Total Service Costs", TargetCosts: total[0], Actuals: total[1], Forecast: total[2] }];
}

function createDataOptC(total, isEditable) {
  return [{ Service: "Total Service Costs", TargetCosts: total[0], Actuals: total[1], Forecast: total[2] }];
}

function createDataRefCCRPrice(ccrCost: any, ccrId: any, isEditable: boolean) {
  return [{ Description: 'CCR', CSId: ccrId, ReferenceScenario: { PerSystem: ccrCost }, IsEditable: isEditable }];
}
function createDataTarCCRPrice(tc: any, fc: any, act: any, tcId: any, fcId: any, actId: any, isEditable: boolean) {
  return [{
    Description: 'CCR', CSIdTargetCost: tcId, CSIdForecast: fcId, CSIdActuals: actId,
    TargetScenario: { TargetCost: { PerSystem: tc }, Forecast: { PerSystem: fc, ActualMEKs: act } },
    IsEditable: isEditable
  }];
}
function createDataOptACCRPrice(tc: any, fc: any, act: any, tcId: any, fcId: any, actId: any, isEditable: boolean) {
  return [{
    Description: 'CCR', CSIdTargetCost: tcId, CSIdForecast: fcId, CSIdActuals: actId,
    OptionA: { TargetCost: { PerSystem: tc }, Forecast: { PerSystem: fc, ActualMEKs: act } },
    IsEditable: isEditable
  }];
}
function createDataOptBCCRPrice(tc: any, fc: any, act: any, tcId: any, fcId: any, actId: any, isEditable: boolean) {
  return [{
    Description: 'CCR', CSIdTargetCost: tcId, CSIdForecast: fcId, CSIdActuals: actId,
    OptionB: { TargetCost: { PerSystem: tc }, Forecast: { PerSystem: fc, ActualMEKs: act } },
    IsEditable: isEditable
  }];
}
function createDataOptCCCRPrice(tc: any, fc: any, act: any, tcId: any, fcId: any, actId: any, isEditable: boolean) {
  return [{
    Description: 'CCR', CSIdTargetCost: tcId, CSIdForecast: fcId, CSIdActuals: actId,
    OptionC: { TargetCost: { PerSystem: tc }, Forecast: { PerSystem: fc, ActualMEKs: act } },
    IsEditable: isEditable
  }];
}

// used to format the cell in germman currency format;
function CurrencyCellRenderer(params: any) {
  const value = params.value;
  if (params.data.Service === "Total Service Costs") {
    return value === undefined || value === null
      ? null
      : new Intl.NumberFormat(countryCode).format(Number(parseFloat(value).toFixed(0)));
  }
  else {
    if (value === undefined || value === null || isNaN(value)) {
      return null;
    }
    if (params.colDef.field === "DeltaFCVsRef" || params.colDef.field === "DeltaTCVsRef" || params.colDef.field === "DeltaACTVsRef") {
      return `${new Intl.NumberFormat(countryCode).format(Number(parseFloat(value).toFixed(2)))}%`;
    }
    return new Intl.NumberFormat(countryCode).format(Number(parseFloat(value).toFixed(2)));
  }
}
// Add this helper outside the class, near CurrencyCellRenderer
function PriceGridValueFormatter(params: any) {
  const value = params.value;
  const description = params.data?.Description;
  const field = params.colDef?.field;

  if (value === undefined || value === null || isNaN(value)) return '';

  if (field === 'DeltaTCVsRef' || field === 'DeltaFCVsRef' || field === 'DeltaACTVsRef') {
    return `${new Intl.NumberFormat(countryCode).format(Number(parseFloat(value).toFixed(2)))}%`;
  }

  if (description === 'Service costs Target' || description === 'Delta Total Service costs to Service costs Target') {
    return new Intl.NumberFormat(countryCode).format(Number(parseFloat(value).toFixed(0)));
  }

  return new Intl.NumberFormat(countryCode).format(Number(parseFloat(value).toFixed(2)));
}
